<template>
  <div style="width:100%;height:100%">
    <!--collapse 是否水平折叠收起菜单-->
    <div v-if="$root.windowstyle == 1">
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab1">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background: #333333;">
            <img src="../assets/img/login/logss.png" class="logimg" @click="refreshLoginInfo" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background: #333333;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" @click="refreshLoginInfo" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;white-space: pre-line;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
            <!-- <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;white-space: pre-line"></span> -->
          </h3>
          <el-menu-item :index="item.path" v-for="item in noChildren" :key="item.path" @click="clickMenu(item)" class="tp1" >
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab2">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background: #333333;">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background: #333333;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren2" :key="item.path" @click="clickMenu(item)" class="tp1">
            <i :class="'el-icon-' + item.icon"></i>
            <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren2" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab3">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background: #333333;">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background: #333333;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren3" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren3" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab5">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background: #333333;">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background: #333333;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren5" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren5" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab4">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background: #333333;">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background: #333333;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren4" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren4" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
    </div>
    <div v-if="$root.windowstyle == 2" class="icon_green">
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab1">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(51,133,86)" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:#0e5e0e">
            <img src="../assets/img/login/logss.png" class="logimg" @click="refreshLoginInfo" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:#0e5e0e;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" @click="refreshLoginInfo" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;white-space: pre-line;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
            <!-- <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;white-space: pre-line"></span> -->
          </h3>
          <el-menu-item :index="item.path" v-for="item in noChildren" :key="item.path" @click="clickMenu(item)" class="tp1" >
            <i :class="'el-icon-' + item.icon"></i>
            <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab2">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(51,133,86)" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:#0e5e0e">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:#0e5e0e;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren2" :key="item.path" @click="clickMenu(item)" class="tp1">
            <i :class="'el-icon-' + item.icon"></i>
            <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren2" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab3">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(51,133,86)" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:#0e5e0e">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:#0e5e0e;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren3" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren3" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab4">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(51,133,86)" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:#0e5e0e">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:#0e5e0e;width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren4" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren4" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
    </div>
    <div v-if="$root.windowstyle == 3">
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab1">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(59,105,161)" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:rgb(35,71,114)">
            <img src="../assets/img/login/logss.png" class="logimg" @click="refreshLoginInfo" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:rgb(35,71,114);width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" @click="refreshLoginInfo" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;white-space: pre-line;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
            <!-- <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;white-space: pre-line"></span> -->
          </h3>
          <el-menu-item :index="item.path" v-for="item in noChildren" :key="item.path" @click="clickMenu(item)" class="tp1" >
            <i :class="'el-icon-' + item.icon"></i>
            <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab2">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(59,105,161)" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:rgb(35,71,114)">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:rgb(35,71,114);width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren2" :key="item.path" @click="clickMenu(item)" class="tp1">
            <i :class="'el-icon-' + item.icon"></i>
            <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren2" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab3">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(59,105,161)" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:rgb(35,71,114)">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:rgb(35,71,114);width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren3" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren3" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab4">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(59,105,161)" text-color="#fff" active-text-color="#ffd04b" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:rgb(35,71,114)">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:rgb(35,71,114);width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren4" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:rgb(255, 208, 75);font-size:16px">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren4" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
    </div>
    <div v-if="$root.windowstyle == 4" class="icon_black">
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab1">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(235,115,154)" text-color="#000" active-text-color="blue" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:rgb(167,45,85)">
            <img src="../assets/img/login/logss.png" class="logimg" @click="refreshLoginInfo" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:rgb(167,45,85);width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" @click="refreshLoginInfo" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
            <!-- <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;white-space: pre-line"></span> -->
          </h3>
          <el-menu-item :index="item.path" v-for="item in noChildren" :key="item.path" @click="clickMenu(item)" class="tp1" >
            <i :class="'el-icon-' + item.icon"></i>
            <span slot="title" style="color:blue;font-size:16px;font-wight:600">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab2">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(235,115,154)" text-color="#000" active-text-color="blue" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:rgb(167,45,85)">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:rgb(167,45,85);width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren2" :key="item.path" @click="clickMenu(item)" class="tp1">
            <i :class="'el-icon-' + item.icon"></i>
            <span slot="title" style="color:blue;font-size:16px;font-wight:600">{{ item.label }}</span>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren2" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab3">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(235,115,154)" text-color="#000" active-text-color="blue" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:rgb(167,45,85)">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:rgb(167,45,85);width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren3" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:blue;font-size:16px;font-wight:600">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren3" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
      <el-scrollbar class="menu" :style="{ height: treeheight }" style="width: 100%;" v-show="tab4">
        <el-menu :collapse="isCollapse" :default-active="path" class="el-menu-demo" background-color="rgb(235,115,154)" text-color="#000" active-text-color="blue" mode="vertical">
          <!--是否水平折叠收起菜单 会影响这里字段的显示 -->
          <h3 v-show="isCollapse" class="logos" style="background:rgb(167,45,85)">
            <img src="../assets/img/login/logss.png" class="logimg" />
          </h3>
          <h3 v-show="!isCollapse" class="logo" style="align-items: center;background:rgb(167,45,85);width: 100%;">
            <img src="../assets/img/login/logss.png" class="logimg" />
            <span style="position: absolute;left: 50px;font-size:15px;line-height:20px;max-width:190px">{{ comName }}<br/>{{ instanceName }}</span>
          </h3>

          <el-menu-item :index="item.path" v-for="item in noChildren4" :key="item.path" @click="clickMenu(item)" class="tp1">
            <template v-if="item.visible">
              <i :class="'el-icon-' + item.icon"></i>
              <span slot="title" style="color:blue;font-size:16px;font-wight:600">{{ item.label }}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="item.label" v-for="(item, index) in hasChildren4" :key="index">
            <template v-if="item.visible">
              <template slot="title">
                <i :class="'el-icon-' + item.icon"></i>
                <span slot="title">{{ item.label }}</span>
              </template>
              <fragment v-for="(subitem, subIndex) in item.children" :key="subIndex">
                <template v-if="subitem.visible">
                  <el-submenu :index="subitem.label" v-if="subitem.chb">
                    <template v-if="subitem.visible">
                      <template slot="title">
                        <i :class="'el-icon-' + subitem.icon"></i>
                        <span slot="title">{{ subitem.label }}</span>
                      </template>
                      <fragment v-for="(subitems, subIndexs) in subitem.children" :key="subIndexs">
                        <el-submenu v-if="subitems.chb" :index="subitems.label">
                          <template v-if="subitems.visible">
                            <template slot="title">
                              <i :class="'el-icon-' + subitems.icon"></i>
                              <span slot="title">{{ subitems.label }}</span>
                            </template>
                          </template>
                          <el-menu-item v-for="(subitemss, subIndexss) in subitems.children" :key="subIndexss" :index="subitemss.path" @click="clickMenu(subitemss)">
                            <template v-if="subitemss.visible">
                              <i :class="'el-icon-' + subitemss.icon"></i>
                              <span slot="title">{{ subitemss.label }}</span>
                            </template>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-if="subitems.visible" :index="subitems.path" @click="clickMenu(subitems)">
                          <template v-if="subitems.visible">
                            <i :class="'el-icon-' + subitems.icon"></i>
                            <span slot="title">{{ subitems.label }}</span>
                          </template>
                        </el-menu-item>
                      </fragment>
                    </template>
                  </el-submenu>
                  <el-menu-item :index="subitem.path" @click="clickMenu(subitem)" v-else-if="subitem.visible">
                    <template v-if="subitem.visible">
                      <i :class="'el-icon-' + subitem.icon"></i>
                      <span slot="title">{{ subitem.label }}</span>
                    </template>
                  </el-menu-item>
                </template>
              </fragment>
            </template>
          </el-submenu>
        </el-menu>
      </el-scrollbar>
    </div>
    <!--<el-tabs tab-position="bottom" style="float:bottom" v-model="activeTabName" @tab-click="changeTabs">
            <el-tab-pane name="1" label="进销存"></el-tab-pane>
            <el-tab-pane name="2" label="生产"></el-tab-pane>
            <el-tab-pane name="3" label="财务"></el-tab-pane>
        </el-tabs>-->
    <div class="menu">
    <div v-show="!isCollapse">
      <el-input v-model="keyword" class="input-with-select" @change="reSetKeyword">
        <el-button size="mini" slot="append" icon="el-icon-arrow-left" @click="previous()"></el-button>
        <el-button size="mini" slot="append" icon="el-icon-arrow-right" @click="next()"></el-button>
      </el-input>
    </div>
    <div v-if="$root.windowstyle == 1">
      <el-menu :collapse="isCollapse" :default-active="activeTabName" class="el-menu-demo" mode="horizontal" @select="changeTabs" background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
        <el-menu-item index="1" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[9]')}}</el-menu-item>
        <el-menu-item index="2" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[19]')}}</el-menu-item>
        <el-menu-item index="3" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[3977]')}}</el-menu-item>
        <el-menu-item index="5" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[12213]')}}</el-menu-item>
        <el-menu-item index="4">KPI</el-menu-item>
      </el-menu>
    </div>
    <div v-if="$root.windowstyle == 2">
      <el-menu :collapse="isCollapse" :default-active="activeTabName" class="el-menu-demo" mode="horizontal" @select="changeTabs" background-color="rgb(51,133,86)" text-color="#fff" active-text-color="#ffd04b">
        <el-menu-item index="1" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[9]')}}</el-menu-item>
        <el-menu-item index="2" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[19]')}}</el-menu-item>
        <el-menu-item index="3" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[3977]')}}</el-menu-item>
        <el-menu-item index="5" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[12213]')}}</el-menu-item>
        <el-menu-item index="4">KPI</el-menu-item>
      </el-menu>
    </div>
    <div v-if="$root.windowstyle == 3">
      <el-menu :collapse="isCollapse" :default-active="activeTabName" class="el-menu-demo" mode="horizontal" @select="changeTabs" background-color="rgb(59,105,161)" text-color="#fff" active-text-color="#ffd04b">
        <el-menu-item index="1" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[9]')}}</el-menu-item>
        <el-menu-item index="2" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[19]')}}</el-menu-item>
        <el-menu-item index="3" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[3977]')}}</el-menu-item>
        <el-menu-item index="5" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[12213]')}}</el-menu-item>
        <el-menu-item index="4">KPI</el-menu-item>
      </el-menu>
    </div>
    <div v-if="$root.windowstyle == 4">
      <el-menu :collapse="isCollapse" :default-active="activeTabName" class="el-menu-demo" mode="horizontal" @select="changeTabs" background-color="rgb(235,115,154)" text-color="#000" active-text-color="blue">
        <el-menu-item index="1" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[9]')}}</el-menu-item>
        <el-menu-item index="2" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[19]')}}</el-menu-item>
        <el-menu-item index="3" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[3977]')}}</el-menu-item>
        <el-menu-item index="5" style="max-width: 60px;padding: 0 8px;">{{$t('getapi[12213]')}}</el-menu-item>
        <el-menu-item index="4">KPI</el-menu-item>
      </el-menu>
    </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CommonAside",
    //计算属性
    computed: {
      //没有子菜单
      noChildren() {
        return this.menu.filter((item) => !item.children);
      },
      //有子菜单 (这样设置会有一个问题 就是有子菜单的 永远会在没有子菜单的下面
      hasChildren() {
        // console.log(this.menu);
        return this.menu.filter((item) => item.children);
      },
      //没有子菜单
      noChildren2() {
        return this.menu2.filter((item) => !item.children);
      },
      //有子菜单 (这样设置会有一个问题 就是有子菜单的 永远会在没有子菜单的下面
      hasChildren2() {
        // console.log(this.menu);
        return this.menu2.filter((item) => item.children);
      },
      //没有子菜单
      noChildren3() {
        return this.menu3.filter((item) => !item.children);
      },
      //有子菜单 (这样设置会有一个问题 就是有子菜单的 永远会在没有子菜单的下面
      hasChildren3() {
        // console.log(this.menu);
        return this.menu3.filter((item) => item.children);
      },
      //没有子菜单
      noChildren4() {
          return this.menu4.filter((item) => !item.children);
      },
      //有子菜单 (这样设置会有一个问题 就是有子菜单的 永远会在没有子菜单的下面
      hasChildren4() {
          // console.log(this.menu);
          return this.menu4.filter((item) => item.children);
      },
      //没有子菜单
      noChildren5() {
          return this.menu5.filter((item) => !item.children);
      },
      //有子菜单 (这样设置会有一个问题 就是有子菜单的 永远会在没有子菜单的下面
      hasChildren5() {
          // console.log(this.menu);
          return this.menu5.filter((item) => item.children);
      },
      isCollapse() {
        // 这里的数据就是从vuex取得
        return this.$store.state.tab.isCollapse;
      },
    },
    data() {
      return {
        menu: [],
        comName: "",
        instanceName:"",
        treeheight: window.innerHeight - 60 + "px",
        tab1: true,
        tab2: false,
        tab3: false,
        tab4: false,
        tab5: false,
        activeTabName: "1",
        menu2: [], //
        menu3: [], //
        menu4: [], //
        menu5: [],
        keyword: '', //模糊匹配菜单
          selectitem: [],
          searchindex: -1,
          path: '',//当前激活菜单名称
      };
    },
    watch: {
      "$i18n.locale": function () {
        // console.log('hello');
        this.setOptions();
      },
    },
    user: {},
    created() {
      this.setOptions();
      this.companyName();
    },
    mounted() {
       let that = this
       this.$changeTab.$on("changeTab", this.changeTabs);
    },
    methods: {
      companyName() {
        var users = sessionStorage.getItem("userData");
        users = JSON.parse(users);
        this.comName = users.Company_Name;
        // this.instanceName = sessionStorage.getItem('instanceName')
        this.instanceName = users.Login_Instance;        
      },
      setOptions() {
          let userdate = JSON.parse(sessionStorage.getItem('userData'))
        this.menu = [
          {
            label: this.$t('getapi[7975]'),
            icon: "s-home",
            chb: false,
            visible: true,
          },
          // {
          // 	label: this.$t('getapi[9]'),
          // 	icon: 's-marketing',
          // 	chb: true,visible:true,
          // 	children: [
          {
            label: this.$t('getapi[9]'),
            icon: "s-home",
            chb: false,
            visible: true,
          },
          {
            //项目工程
            label: this.$t("getapi[18]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //项目工程-物料主文件
                label: this.$t("getapi[55]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "29|301|311|149",
                  1
                ),
                children: [
                  {
                    //物料主文件一览
                    path: "/mater",
                    name: "mater",
                    label: this.$t("getapi[56]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 29, 1),
                    url: "project/materialsview",
                  },
                  {
                    //不可用设置
                    path: "/invalidsetting",
                    name: "invalidsetting",
                    label: this.$t("getapi[60]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 301, 1),
                    url: "project/invalidsetting",
                  },
                  {
                    //计划相关设置
                    path: "/planningdatasetting",
                    name: "planningdatasetting",
                    label: this.$t("getapi[6011]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 311, 1),
                    url: "project/planningdatasetting",
                  },
                  {
                    //质量相关设置
                    path: "/qualitysetting",
                    name: "qualitysetting",
                    label: this.$t("getapi[6012]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 149, 1),
                    url: "project/qualitysetting",
                  },
                  {
                    //基础信息设置
                    path: "/partbaseinfosetting",
                    name: "partbaseinfosetting",
                    label: this.$t("getapi[13087]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 596, 1),
                    url: "project/partbaseinfosetting",
                  },
                  {
                    //物料自由项导入
                    path: "/partgroupimport",
                    name: "partgroupimport",
                    label: this.$t("getapi[8961]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 561, 1),
                    url: "project/partgroupimport",
                  },
                ],
              },
              {
                //项目工程-工艺信息
                label: this.$t("getapi[63]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "27|28|38|392",
                  1
                ),
                children: [
                  {
                    //工艺一览
                    path: "/carft",
                    name: "carft",
                    label: this.$t("getapi[64]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 27, 1),
                    url: "project/carft",
                  },
                  /* {
                                      path: '/carftn',
                                      name: 'carftn',
                                      label: '工艺测试页面',
                                      icon: 'arrow-right',
                                      chb: false,
                                      visible: true,
                                      url: 'project/carftn'
                                  }, */
                  {
                    //工艺明细概览
                    path: "/carftview",
                    name: "carftview",
                    label: this.$t("getapi[65]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 27, 1),
                    url: "project/carftview",
                  },
                  {
                    //工艺工时导入、工艺备注导入、工艺流转方向导入
                    path: "/carftexp",
                    name: "carftexp",
                    label: this.$t("getapi[6530]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.SecondMenuVisible(
                      "plv2",
                      "28|38|392",
                      1
                    ), //this.$limits.menuvisible('plv2',28,1)||this.$limits.menuvisible('plv2',38,1)||this.$limits.menuvisible('plv2',392,1),
                    url: "project/carftexp",
                  },
                  {
                      //工艺状态设置
                      path: "/carftstatussetting",
                      name: "carftstatussetting",
                      label: this.$t("getapi[12897]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: this.$limits.menuvisible("plv2", 27, 1),
                      url: "project/carftstatussetting",
                  },
                ],
              },
              {
                //项目工程-BOM信息
                label: this.$t("getapi[68]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "31|32|303", 1),
                children: [
                  {
                    //BOM
                    path: "/BOM",
                    name: "BOM",
                    label: this.$t("getapi[6010]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 31, 1),
                    url: "project/BOM",
                  },
                  {
                    //BOM明细一览
                    path: "/overviewBOM",
                    name: "overviewBOM",
                    label: this.$t("getapi[69]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 32, 1),
                    url: "project/overviewBOM",
                  },
                  {
                    //BOM物料替换
                    path: "/replace",
                    name: "replace",
                    label: this.$t("getapi[71]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 303, 1),
                    url: "project/replace",
                  },
                  {
                    //BOM反向遍历查询
                    path: "/reverses",
                    name: "reverses",
                    label: this.$t("getapi[73]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 480, 1),
                    url: "project/reverses",
                  },
                  {
                    //BOM下相同工序号检查
                    path: "/checkbomsaferout",
                    name: "checkbomsaferout",
                    label: this.$t("getapi[6361]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 31, 1),
                    url: "project/checkbomsaferout",
                  },
                  {
                    //BOM工序号异常数据
                    path: "/partbomsequenceabnor",
                    name: "partbomsequenceabnor",
                    label: this.$t("getapi[12570]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 31, 1),
                    url: "project/partbomsequenceabnor",
                  },
                  {
                    //批量验证bom是否有效
                    path: "/checkbom",
                    name: "checkbom",
                    label: this.$t("getapi[6123]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 481, 1),
                    url: "project/checkbom",
                  },
                  {
                    //BOM不可用导出
                    path: "/bomunexport",
                    name: "bomunexport",
                    label: this.$t("getapi[8179]"),
                    icon: "arrow-right",
                    chb: false,
                    visible:  this.$limits.menuvisible("plv2", 31, 1),
                    url: "project/bomunexport",
                  },
                  {
                    //BOM采购件工序下挂清单
                    path: "/bomprocesslist",
                    name: "bomprocesslist",
                    label: this.$t("getapi[13174]"),
                    icon: "arrow-right",
                    chb: false,
                    visible:  this.$limits.menuvisible("plv2", 31, 1),
                    url: "project/bomprocesslist",
                  },
                  {
                    //BOM产成品物料清单
                    path: "/bomfppartlist",
                    name: "bomfppartlist",
                    label: this.$t("getapi[13265]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 31, 1),
                    url: "project/bomfppartlist",
                  },
                ],
              },
              //ECN管理
              {
                //项目工程-ECN管理
                label: this.$t("getapi[6124]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "31|32|36|303", 1),
                children: [
                  {
                    //ecr
                    path: "/ecrlist",
                    name: "ecrlist",
                    label: this.$t("getapi[13042]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 595, 1),
                    url: "project/ecn",
                  },
                  {
                    //ecn
                    path: "/ecnlist",
                    name: "ecnlist",
                    label: this.$t("getapi[6125]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 36, 1),
                    url: "project/ecn",
                  },
                  // ECN类型
                  {
                    path: "/ecntype",
                    name: "ecntype",
                    label: this.$t("getapi[6126]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 35, 1),
                    url: "project/ecntype",
                  },
                  // 产品当前阶段
                  {
                    path: "/ecnnew",
                    name: "ecnnew",
                    label: this.$t("getapi[6127]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 35, 1),
                    url: "project/ecnnew",
                  },
                  // 会签人员
                  {
                    path: "/ecnperson",
                    name: "ecnperson",
                    label: this.$t("getapi[6128]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 35, 1),
                    url: "project/ecnperson",
                  },
                  // 实施条目
                  {
                    path: "/ecnitem",
                    name: "ecnitem",
                    label: this.$t("getapi[6129]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 35, 1),
                    url: "project/ecnitem",
                  },
                  // 分发部门
                  {
                    path: "/ecndep",
                    name: "ecndep",
                    label: this.$t("getapi[6130]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 35, 1),
                    url: "project/ecndep",
                  },
                  {
                    //计划负责人
                    path: "/ecnprojectuser",
                    name: "ecnprojectuser",
                    label: this.$t("getapi[12767]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 35, 1),
                    url: "project/ecnprojectuser",
                  },
                  {
                    //Ecn内物料清单
                    path: "/ecnsubsetparts",
                    name: "ecnsubsetparts",
                    label: this.$t("getapi[13180]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "project/ecnsubsetparts",
                  },
                ],
              },
              //CAR信息
              //WI&II
              {
                //WI&II
                label: "WI&II",
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  {
                    //wi&ii概览
                    path: "/wi&iidetail",
                    name: "wi&iidetail",
                    label: this.$t("getapi[6531]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 356, 1),
                    url: "project/WI&II/wi&iidetail",
                  },
                  {
                    //wi&ii明细
                    path: "/wi&iiinfo",
                    name: "wi&iiinfo",
                    label: this.$t("getapi[6532]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 356, 1),
                    url: "project/WI&II/wi&iiinfo",
                  },
                  {
                    //wi&ii执行人
                    path: "/wi&iiexecuter",
                    name: "wi&iiexecuter",
                    label: this.$t("getapi[497]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 356, 1),
                    url: "project/WI&II/wi&iiexecuter",
                  },
                  {
                    //WI项目人员列表
                    path: "/wiiidluser",
                    name: "wiiidluser",
                    label: this.$t("getapi[12748]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 356, 1),
                    url: "project/WI&II/wiiidluser",
                  },
                ],
              },
                //工装评估
                {
                    //TM概览
                    label: this.$t("getapi[6533]"),
                    icon: "caret-right",
                    chb: true,
                    visible: true,
                    children: [
                        {
                            //TM概览
                            path: "/tmdetail",
                            name: "tmdetail",
                            label: this.$t("getapi[6534]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 520, 1),
                            url: "project/TM/tmdetail",
                        },
                        {
                            //TM明细
                            path: "/tminfo",
                            name: "tminfo",
                            label: this.$t("getapi[6535]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 520, 1),
                            url: "project/TM/tminfo",
                        },
                        {
                            //wi&ii执行人
                            path: "/tmexecuter",
                            name: "tmexecuter",
                            label: this.$t("getapi[6536]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 520, 1),
                            url: "project/TM/tmexecuter",
                        },
                    ],
                },
              /* 新品评估 */
              {
                label: this.$t("getapi[6537]"),
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  /*{
                    path: "/npplan",
                    name: "npplan",
                    label: this.$t("getapi[1091]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,//this.$limits.menuvisible("plv2", 356, 1),
                    url: "project/newproduct/npplan",
                  },
                  {
                    path: "/nppartcode",
                    name: "nppartcode",
                    label: this.$t("getapi[6538]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,//this.$limits.menuvisible("plv2", 356, 1),
                    url: "project/newproduct/nppartcode",
                  },*/
                    {
                        path: "/newproeval",
                        name: "newproeval",
                        label: this.$t("getapi[8924]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 560, 1),
                        url: "project/itemmanage/newproeval",
                    },
                ],
              },
                /* 项目管理 */
                {
                    label: this.$t("getapi[7934]"),
                    icon: "caret-right",
                    chb: true,
                    visible: true,
                    children: [
                        {
                            path: "/itemmanage",
                            name: "itemmanage",
                            label: this.$t("getapi[7934]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 527, 1),
                            url: "project/itemmanage/itemmanage",
                        },
                        {
                            path: "/itemimple",
                            name: "itemimple",
                            label: this.$t("getapi[7935]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 527, 1),
                            url: "project/itemmanage/itemimple",
                        },
                        {
                            path: "/itemimpletemp",
                            name: "itemimpletemp",
                            label: this.$t("getapi[7994]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 527, 1),
                            url: "project/itemmanage/itemimpletemp",
                        },
                        {
                            path: "/itemsign",
                            name: "itemsign",
                            label: this.$t("getapi[6128]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 527, 1),
                            url: "project/itemmanage/itemsign",
                        },
                    ],
                },
                /* 机加工管理 */
                {
                    label: this.$t("getapi[8254]"),
                    icon: "caret-right",
                    chb: true,
                    visible: true,
                    children: [
                        {
                            path: "/engmevtview",
                            name: "engmevtview",
                            label: this.$t("getapi[8255]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 556, 1),
                            url: "project/engmevt/engmevtview",
                        },
                        {
                            path: "/mevtcraftprocprice",
                            name: "mevtcraftprocprice",
                            label: this.$t("getapi[13221]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 556, 1),
                            url: "project/engmevt/mevtcraftprocprice",
                        },
                        {
                            path: "/engmevtviewxp",
                            name: "engmevtviewxp",
                            label: this.$t("getapi[13226]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 556, 1),
                            url: "project/engmevt/engmevtviewxp",
                        },
                        {
                            path: "/machinieinfoevttridview",
                            name: "machinieinfoevttridview",
                            label: this.$t("getapi[12701]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 556, 1),
                            url: "project/engmevt/machinieinfoevttridview",
                        },
                    ],
                }
            ],
          },
          {
            //供应商开发
            label: this.$t("getapi[17]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              // {
              // 	path: '/purchase',
              // 	name: 'purchase',
              // 	label: this.$t('getapi[80]'),
              // 	icon: 'caret-right',
              // 	chb: false,visible:true,
              // 	url: 'menu1/supplier/purchase'
              // },
              {
                label: this.$t("getapi[83]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "46|", 1),
                children: [
                  {
                    //供应商信息一览
                    path: "/suplist",
                    name: "suplist",
                    label: this.$t("getapi[84]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 46, 1),
                    url: "menu1/supplier/supplier/list",
                  },
                  // {
                  //   //批量更新供应商信息
                  //   path: "/exp/24",
                  //   name: "exp",
                  //   label: this.$t("getapi[6539]"),
                  //   icon: "arrow-right",
                  //   chb: false,
                  //   visible: this.$limits.menuvisible("plv2", 357, 1),
                  //   params: {
                  //     id: 24,
                  //   },
                  //   url: "/exp/24",
                  // },
                  {
                    //批量更新供应商信息
                    path: "/venderbatchupdate",
                    name: "venderbatchupdate",
                    label: this.$t("getapi[6539]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 357, 1),
                    url: "menu1/supplier/supplier/venderbatchupdate",
                  },
                  // {
                  // 	path: '/supedit',
                  // 	name: 'supedit',
                  // 	label: this.$t('getapi[85]'),
                  // 	icon: 'arrow-right',
                  // 	chb: false,visible:true,
                  // 	url: 'menu1/supplier/supplier/edit'
                  // },
                    {
                        //A类供应商现场审核清单
                        path: "/venderainfo",
                        name: "venderainfo",
                        label: this.$t("getapi[13504]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 46, 1),
                        url: "menu1/supplier/supplier/venderainfo",
                    },
                ],
              },
              {
                //采购价格信息
                label: this.$t("getapi[86]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "341|44|478",
                  1
                ),
                children: [
                  {
                    //价格变更历史
                    path: "/schqtchangehistory",
                    name: "schqtchangehistory",
                    label: this.$t("getapi[87]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 341, 1),
                    url: "menu1/supplier/purchaseprice/schqtchangehistory",
                  },
                  {
                    //价格表单一览
                    path: "/ppoverview",
                    name: "ppoverview",
                    label: this.$t("getapi[88]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 44, 1),
                    url: "menu1/supplier/purchaseprice/ppoverview",
                  },
                  {
                    //待修改moq一览
                    path: "/moqupdate",
                    name: "moqupdate",
                    label: this.$t("getapi[6543]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 478, 1),
                    url: "menu1/supplier/purchaseprice/moqupdate",
                  },
                ],
              },
                {
                    //采购价格信息
                    label: this.$t("getapi[13175]"),
                    icon: "caret-right",
                    chb: true,
                    visible: this.$limits.SecondMenuVisible(
                        "plv2",
                        "153|345|342|473|476|48|51|44",
                        1
                    ),
                    children: [
                        {
                            //批量价格一览
                            path: "/ppbatchoverview",
                            name: "ppbatchoverview",
                            label: this.$t("getapi[6014]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 153, 1),
                            url: "menu1/supplier/purchaseprice/ppbatchoverview",
                        },
                        {
                            //批量价格一览
                            path: "/ppbatchoverimp",
                            name: "ppbatchoverimp",
                            label: this.$t("getapi[13176]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 345, 1),
                            url: "menu1/supplier/purchaseprice/ppbatchoverimp",
                        },
                        {
                            //价格趋势曲线
                            path: "/chartss",
                            name: "chartss",
                            label: this.$t("getapi[91]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 342, 1),
                            url: "menu1/supplier/purchaseprice/chartss",
                        },
                        {
                            //价格请示书
                            path: "/pricereq",
                            name: "pricereq",
                            label: this.$t("getapi[6540]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: (this.$limits.menuvisible("plv2", 473, 1) && this.$limits.authority_pricereq('A80')),
                            url: "menu1/supplier/purchaseprice/pricereq",
                        },
                        {
                            //价格请示书概览
                            path: "/pricedetail",
                            name: "pricedetail",
                            label: this.$t("getapi[8198]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: (this.$limits.menuvisible("plv2", 473, 1) && this.$limits.authority_pricereq('A80')),
                            url: "menu1/supplier/purchaseprice/pricedetail",
                        },
                        {
                            //价格请示书审批
                            path: "/pricereqapprove",
                            name: "pricereqapprove",
                            label: this.$t("getapi[6541]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: (this.$limits.menuvisible("plv2", 473, 1) && this.$limits.authority_pricereq('A80')),
                            url: "menu1/supplier/purchaseprice/pricereqapprove",
                        },
                        {
                            //价格申请书审批模板
                            path: "/priceapplication",
                            name: "priceapplication",
                            label: this.$t("getapi[6542]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: (this.$limits.menuvisible("plv2", 476, 1) && this.$limits.authority_pricereq('A80')),
                            url: "menu1/supplier/purchaseprice/priceapplication",
                        },
                        {
                            //采购价格变更单一览
                            path: "/schqtchangelineview",
                            name: "schqtchangelineview",
                            label: this.$t("getapi[92]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 48, 1),
                            url: "menu1/supplier/purchaseprice/schqtchangelineview",
                        },
                        {
                            //采购价格变更单概览
                            path: "/schqtchangelinedetail",
                            name: "schqtchangelinedetail",
                            label: this.$t("getapi[93]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 48, 1),
                            url: "menu1/supplier/purchaseprice/schqtchangelinedetail",
                        },
                        {
                            //降价金额查询
                            path: "/quojiang",
                            name: "quojiang",
                            label: this.$t("getapi[95]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 51, 1),
                            url: "menu1/supplier/purchaseprice/quojiang",
                        },
                        {
                            //有效BOM中有无效价格
                            path: "/bomeffective",
                            name: "bomeffective",
                            label: this.$t("getapi[6371]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 44, 1),
                            url: "menu1/supplier/purchaseprice/bomeffective",
                        },
                    ],
                },
              /*{
                                      path: '/depreciate',
                                      name: 'depreciate',
                                      label: this.$t('getapi[96]'),
                                      icon: 'caret-right',
                                      chb: false,visible:true,
                                      url: 'menu1/supplier/depreciate'
                                  },
                                  {
                                      path: '/prosource',
                                      name: 'prosource',
                                      label: '采购源开发',
                                      icon: 'caret-right',
                                      chb: false,visible:true,
                                      url: 'menu1/supplier/prosource'
                                  }*/
              {
                label: this.$t("getapi[6544]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "229|234|347", 1),
                children: [
                  {
                    //基础零件
                    path: "/purrfqbpart",
                    name: "purrfqbpart",
                    label: this.$t("getapi[6545]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 229, 1),
                    url: "menu1/supplier/supplier/purrfqb/purrfqbpart",
                  },
                  {
                    //报价信息
                    path: "/purrfqquotation",
                    name: "purrfqquotation",
                    label: this.$t("getapi[6546]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 234, 1),
                    url: "menu1/supplier/supplier/purrfqb/purrfqquotation",
                  },
                  {
                    //询报价一览
                    path: "/purrfq",
                    name: "purrfq",
                    label: this.$t("getapi[6547]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 347, 1),
                    url: "menu1/supplier/supplier/purrfqb/purrfq",
                  },
                  {
                      //供应商竞价一览
                      path: "/purvenderrfq",
                      name: "purvenderrfq",
                      label: this.$t("getapi[12689]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "menu1/supplier/supplier/purrfqb/purvenderrfq",
                  },
                ],
              },
            ],
          },
          {
            //采购管理
            label: this.$t("getapi[16]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //采购计划
                label: this.$t("getapi[97]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "57|65|74", 1),
                children: [
                  {
                    //采购计划一览
                    path: "/purschemeview",
                    name: "purschemeview",
                    label: this.$t("getapi[1138]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 57, 1),
                    url: "menu1/purchasing/purschemeview",
                  },
                  {
                    //采购计划明细概览
                    path: "/purschemedetailview",
                    name: "purschemedetailview",
                    label: this.$t("getapi[98]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 65, 1),
                    url: "menu1/purchasing/purschemedetailview",
                  },
                    {
                        //采购计划明细导入
                        path: "/purschemeimport",
                        name: "purschemeimport",
                        label: this.$t("getapi[7933]"),
                        icon: "caret-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 65, 1),
                        url: "menu1/purchasing/purschemeimport",
                    },
                  {
                    //模拟配料
                    path: "/schemesimulation",
                    name: "schemesimulation",
                    label: this.$t("getapi[100]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 74, 1),
                    url: "menu1/purchasing/schemesimulation",
                  },
                  {
                    //采购件模拟配料
                    path: "/purschemesimulation",
                    name: "purschemesimulation",
                    label: this.$t("getapi[6548]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 74, 1),
                    url: "menu1/purchasing/purschemesimulation",
                  },
                  {
                    //包材计划
                    path: "/packplan",
                    name: "packplan",
                    label: this.$t("getapi[6549]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 164, 1),
                    url: "menu1/purchasing/packplan",
                  },
                ],
              },
              {
                //采购订单
                label: this.$t("getapi[101]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "59|61|66|360,322", 1) || this.$limits.SecondMenuVisible("plv4", "360|", 1),
                children: [
                  {
                    //计划下单一览
                    path: "/purorderplanview",
                    name: "purorderplanview",
                    label: this.$t("getapi[102]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 59, 1),
                    url: "menu1/purchasing/purorder/purorderplanview",
                  },
                  {
                    //采购订单一览
                    path: "/purorderview",
                    name: "purorderview",
                    label: this.$t("getapi[103]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 61, 1),
                    url: "menu1/purchasing/purorder/purorderview",
                  },{
                    //采购订单明细概览
                    path: "/purorderdetailview",
                    name: "purorderdetailview",
                    label: this.$t("getapi[104]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 66, 1),
                    url: "menu1/purchasing/purorder/purorderdetailview",
                  },
                  {
                      //采购-FA清单一览
                      path: "/purfaview",
                      name: "purfaview",
                      label: this.$t("getapi[13528]"),
                      icon: "caret-right",
                      chb: false,
                      visible: true,
                      url: "menu1/purchasing/purorder/purfaview",
                  },
                  {
                    //交期批量变更
                    path: "/purorderbatchchange",
                    name: "purorderbatchchange",
                    label: this.$t("getapi[106]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 482, 1),
                    url: "menu1/purchasing/purorder/purorderbatchchange",
                  },
                  {
                    //MRO预算
                    path: "/purmrobudge",
                    name: "purmrobudge",
                    label: this.$t("getapi[6550]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 322, 1),
                    url: "menu1/purchasing/purorder/purmrobudge",
                  },
                ],
              },
              {
                //采购收货信息
                label: this.$t("getapi[107]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "211|213", 1),
                children: [
                  {
                    //收货单一览
                    path: "/purreceiveview",
                    name: "purreceiveview",
                    label: this.$t("getapi[108]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 211, 1),
                    url: "menu1/purchasing/purreceive/purreceiveview",
                  },
                  {
                    //收货单明细
                    path: "/purreceivedetailview",
                    name: "purreceivedetailview",
                    label: this.$t("getapi[955]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 213, 1),
                    url: "menu1/purchasing/purreceive/purreceivedetailview",
                  },
                ],
              },
              {
                //采购入库信息
                label: this.$t("getapi[956]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "214|216", 1),
                children: [
                  {
                    //采购入库单一览
                    path: "/purgrnview",
                    name: "purgrnview",
                    label: this.$t("getapi[957]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 214, 1),
                    url: "menu1/purchasing/purgrn/purgrnview",
                  },
                  {
                    //采购入库单概览
                    path: "/purgrndetailview",
                    name: "purgrndetailview",
                    label: this.$t("getapi[959]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 216, 1),
                    url: "menu1/purchasing/purgrn/purgrndetailview",
                  },
                ],
              },
              {
                //采购退货信息
                label: this.$t("getapi[960]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "217", 1),
                children: [
                  {
                    path: "/purreturnview",
                    name: "purreturnview",
                    label: this.$t("getapi[961]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 217, 1),
                    url: "menu1/purchasing/purreturn/purreturnview",
                  },
                  {
                    path: "/purreturndetailview",
                    name: "purreturndetailview",
                    label: this.$t("getapi[962]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 217, 1),
                    url: "menu1/purchasing/purreturn/purreturndetailview",
                  },
                ],
              },
              {
                //采购统计
                label: this.$t("getapi[964]"),
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                  {
                    //采购及时交付率
                    path: "/purrateview",
                    name: "purrateview",
                    label: this.$t("getapi[965]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 67, 1) && userdate.Login_DB != 'WGZC',
                    url: "menu1/purchasing/purstatistics/purrateview",
                  },
                    {
                        //采购及时交付率（武滚）
                        path: "/purrateview_wg",
                        name: "purrateview_wg",
                        label: this.$t("getapi[965]"),
                        icon: "caret-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 67, 1) && userdate.Login_DB == 'WGZC',
                        url: "menu1/purchasing/purstatistics/purrateview_wg",
                    },
                  {
                    //采购质量合格率
                    path: "/ppmview",
                    name: "ppmview",
                    label: this.$t("getapi[966]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 70, 1),
                    url: "menu1/purchasing/purstatistics/ppmview",
                  },
                  {
                    //年度质量合格率
                    path: "/yearppmview",
                    name: "yearppmview",
                    label: this.$t("getapi[967]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 70, 1),
                    url: "menu1/purchasing/purstatistics/yearppmview",
                  },
                  {
                    //ppv一览
                    path: "/ppvview",
                    name: "ppvview",
                    label: this.$t("getapi[968]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 70, 1),
                    url: "menu1/purchasing/purstatistics/ppvview",
                  },
                  {
                    //ppv综合统计
                    path: "/buyerppv",
                    name: "buyerppv",
                    label: this.$t("getapi[969]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 72, 1),
                    url: "menu1/purchasing/purstatistics/buyerppv",
                  },
                  {
                    //供应商采购金额统计
                    path: "/puracquisition",
                    name: "puracquisition",
                    label: this.$t("getapi[970]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 73, 1),
                    url: "menu1/purchasing/purstatistics/puracquisition",
                  },
                  {
                    //采购员采购金额统计
                    path: "/purstatbuyer",
                    name: "purstatbuyer",
                    label: this.$t("getapi[8011]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 528, 1),
                    url: "menu1/purchasing/purstatistics/purstatbuyer",
                  },
                  {
                    //采购的未开票统计
                    path: "/purnolnvoiceview",
                    name: "purnolnvoiceview",
                    label: this.$t("getapi[971]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 75, 1),
                    url: "menu1/purchasing/purstatistics/purnolnvoiceview",
                  },
                  {
                    //采购预测
                    path: "/purforecast",
                    name: "purforecast",
                    label: this.$t("getapi[6551]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 502, 1),
                    url: "menu1/purchasing/purstatistics/purforecast",
                  },
                ],
              },
              {
                //采购审批
                label: this.$t("getapi[6029]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "155|", 1),
                children: [
                  {
                    //采购审批模板一览
                    path: "/purapprovalview",
                    name: "purapprovalview",
                    label: this.$t("getapi[6030]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 155, 1),
                    url: "menu1/purchasing/purapproval/purapprovalview",
                  },
                ],
              },
              {
                //FA第三方报告
                label: this.$t("getapi[13246]"),
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                  {
                    //FA第三方报告
                    path: "/fareportview",
                    name: "fareportview",
                    label: this.$t("getapi[13246]"),
                    icon: "caret-right",
                    chb: false,
                    visible:true,
                    url: "menu1/fareport/fareportview",
                  },
                ],
              },
            ],
          },
          {
            //MRB
              label: this.$t("getapi[8513]"),
              icon: "video-play",
              chb: true,
              visible: true,
              children: [
                  {
                      //项目工程-CAR信息
                      label: this.$t("getapi[6204]"),
                      icon: "video-play",
                      chb: true,
                      visible: true,
                      children: [
                          {
                              //ecn
                              path: "/carview",
                              name: "carview",
                              label: this.$t("getapi[6205]"),
                              icon: "arrow-right",
                              chb: false,
                              visible: this.$limits.menuvisible("plv2", 318, 1),
                              url: "project/car/carview",
                          },
                      ],
                  },
                  {
                      label: 'MRB',
                      icon: "video-play",
                      chb: true,
                      visible: true,
                      children: [
                          {
                              //待生成mrb单据
                              path: "/mrbreportlist",
                              name: "mrbreportlist",
                              label: this.$t("getapi[8524]"),
                              icon: "caret-right",
                              chb: false,
                              visible: true,
                              url: "menu1/mrb/mrbreportlist",
                          },
                          {
                              //mrb一览
                              path: "/mrbview",
                              name: "mrbview",
                              label: this.$t("getapi[8508]"),
                              icon: "caret-right",
                              chb: false,
                              visible: this.$limits.menuvisible("plv2", 592, 1),
                              url: "menu1/mrb/mrbview",
                          },
                          {
                              //mrb概览
                              path: "/mrbdetailview",
                              name: "mrbdetailview",
                              label: this.$t("getapi[13008]"),
                              icon: "caret-right",
                              chb: false,
                              visible: this.$limits.menuvisible("plv2", 592, 1),
                              url: "menu1/mrb/mrbdetailview",
                          },
                          {
                              //waiver一览
                              path: "/wavierview",
                              name: "wavierview",
                              label: this.$t("getapi[13276]"),
                              icon: "caret-right",
                              chb: false,
                              visible: this.$limits.menuvisible("plv2", 592, 1),
                              url: "menu1/mrb/wavierview",
                          },
                      ],
                  },
              ],
          },
          {
            //库存管理
            label: this.$t("getapi[15]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //材料出入库单
                label: this.$t("getapi[972]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "77|87|95|96", 1),
                children: [
                  {
                    //材料入库一览
                    path: "/InvInView",
                    name: "InvInView",
                    label: this.$t("getapi[973]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 77, 1),
                    url: "menu1/Inv/InvInOut/InvInView",
                  },
                  {
                    //材料入库明细概览
                    path: "/InvInDetailView",
                    name: "InvInDetailView",
                    label: this.$t("getapi[974]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 87, 1),
                    url: "menu1/Inv/InvInOut/InvInDetailView",
                  },
                  /*{
                                              path: '/InvInManager',
                                              name: 'InvInManager',
                                              label: this.$t('getapi[975]'),
                                              icon: 'caret-right',
                                              chb: false,visible:true,
                                              url: 'menu1/Inv/InvInOut/InvInManager'
                                          },*/
                  {
                    //通用出库一览
                    path: "/InvOutView",
                    name: "InvOutView",
                    label: this.$t("getapi[976]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 95, 1),
                    url: "menu1/Inv/InvInOut/InvOutView",
                  },
                  {
                    //通用出库明细概览
                    path: "/InvOutDetailView",
                    name: "InvOutDetailView",
                    label: this.$t("getapi[977]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 96, 1),
                    url: "menu1/Inv/InvInOut/InvOutDetailView",
                  },
                  /* {
                                              path: '/InvOutManager',
                                              name: 'InvOutManager',
                                              label: this.$t('getapi[978]'),
                                              icon: 'caret-right',
                                              chb: false,visible:true,
                                              url: 'menu1/Inv/InvInOut/InvOutManager'
                                          } */
                ],
              },

              // {
              // 	label: this.$t('getapi[3066]'),
              // 	icon: 'video-play',
              // 	chb: true,
              // 	visible: true,
              // 	children: [
              // 		// 库存管理-出入库执行-通用出库执行
              // 		{
              // 			path: '/general',
              // 			name: 'general',
              // 			label: this.$t('getapi[2238]'),
              // 			icon: 'caret-right',
              // 			chb: false,
              // 			visible: this.$limits.menuvisible('plv2', 283, 1),
              // 			url: 'menu1/Inv/InvCarry/general'
              // 		},
              // 		// 库存管理-出入库执行-通用红字出库执行
              // 		{
              // 			path: '/generalred',
              // 			name: 'generalred',
              // 			label: '通用红字执行',
              // 			icon: 'caret-right',
              // 			chb: false,
              // 			visible: this.$limits.menuvisible('plv2', 284, 1),
              // 			url: 'menu1/Inv/InvCarry/generalred'
              // 		},
              // 		// 库存管理-出入库执行-销售发货执行
              // 		{
              // 			path: '/salsend',
              // 			name: 'salsend',
              // 			label: '销售发货蓝字执行',
              // 			icon: 'caret-right',
              // 			chb: false,
              // 			visible: this.$limits.menuvisible('plv2', 111, 1),
              // 			url: 'menu1/Inv/InvCarry/salsend'
              // 		}
              // 		// 库存管理-出入库执行-销售退货执行
              // 		// {
              // 		// 	path: '/salreturn',
              // 		// 	name: 'salreturn',
              // 		// 	label: '销售发货红字执行',
              // 		// 	icon: 'caret-right',
              // 		// 	chb: false,visible:true,
              // 		// 	url: 'menu1/Inv/InvCarry/salreturn'
              // 		// }
              // 	]
              // },
              //移库和盘点
              {
                label: this.$t("getapi[6107]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "85|81", 1),
                children: [
                  {
                    //移库一览
                    path: "/InvMoveView",
                    name: "InvMoveView",
                    label: this.$t("getapi[985]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 85, 1),
                    url: "menu1/Inv/InvManager/InvMoveView",
                  },
                  {
                    //盘点报告一览
                    path: "/InvCheckView",
                    name: "InvCheckView",
                    label: this.$t("getapi[980]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 81, 1),
                    url: "menu1/Inv/InvCheck/InvCheckView",
                  },
                  {
                    //盘点明细概览
                    path: "/InvCheckDetailView",
                    name: "InvCheckDetailView",
                    label: this.$t("getapi[2324]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 81, 1),
                    url: "menu1/Inv/InvCheck/InvCheckDetailView",
                  },
                  // {
                  // 	path: '/InvCheckManager',
                  // 	name: 'InvCheckManager',
                  // 	label: this.$t('getapi[981]'),
                  // 	icon: 'caret-right',
                  // 	chb: false,visible:true,
                  // 	url: 'menu1/Inv/InvCheck/InvCheckManager'
                  // }
                ],
              },
              {
                //库存管理
                label: this.$t("getapi[6108]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "83|84|90|308|387|378",
                  1
                ),
                children: [
                  {
                    //库存一览
                    path: "/InvInfoView",
                    name: "InvInfoView",
                    label: this.$t("getapi[982]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 83, 1),
                    url: "menu1/Inv/InvManager/InvInfoView",
                  },
                  {
                    //库存事务一览
                    path: "/InvTransView",
                    name: "InvTransView",
                    label: this.$t("getapi[983]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 84, 1),
                    url: "menu1/Inv/InvManager/InvTransView",
                  },

                  // {
                  // 	path: '/InvMoveManager',
                  // 	name: 'InvMoveManager',
                  // 	label: this.$t('getapi[986]'),
                  // 	icon: 'caret-right',
                  // 	chb: false,visible:true,
                  // 	url: 'menu1/Inv/InvManager/InvMoveManager'
                  // },
                  {
                    //货位管理
                    path: "/CargoManager",
                    name: "CargoManager",
                    label: this.$t("getapi[989]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 90, 1),
                    url: "menu1/Inv/InvManager/CargoManager",
                  },
                  {
                    //库存账龄一览-正向
                    path: "/InvAgingForwardView",
                    name: "InvAgingForwardView",
                    label: this.$t("getapi[991]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 308, 1),
                    url: "menu1/Inv/InvManager/InvAgingForwardView",
                  },
                    {
                        //库存账龄一览-正向(新)
                        path: "/InvAgingForwardViewNew",
                        name: "InvAgingForwardViewNew",
                        label: this.$t("getapi[13137]"),
                        icon: "caret-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 308, 1),
                        url: "menu1/Inv/InvManager/InvAgingForwardViewNew",
                    },
                  {
                    //库存账龄计算-正向
                    path: "/InvAgingForwardCalculate",
                    name: "InvAgingForwardCalculate",
                    label: this.$t("getapi[992]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 387, 1),
                    url: "menu1/Inv/InvManager/InvAgingForwardCalculate",
                  },
                    {
                        //实时库存
                        path: "/DailyInventory",
                        name: "DailyInventory",
                        label: this.$t("getapi[13138]"),
                        icon: "caret-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 308, 1),
                        url: "menu1/Inv/InvManager/DailyInventory",
                    },
                  {
                    //库存物料订购点一览
                    path: "/InvPartView",
                    name: "InvPartView",
                    label: this.$t("getapi[994]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 378, 1),
                    url: "menu1/Inv/InvManager/InvPartView",
                  },
                    {
                        //溯源
                        path: "/Traceability",
                        name: "Traceability",
                        label: this.$t("getapi[12592]"),
                        icon: "caret-right",
                        chb: false,
                        visible: true,
                        url: "menu1/Inv/InvManager/Traceability",
                    },
                    {
                        //溯源
                        path: "/XJToMLXYPartPrice",
                        name: "XJToMLXYPartPrice",
                        label: this.$t("getapi[12949]"),
                        icon: "caret-right",
                        chb: false,
                        visible: true,
                        url: "menu1/Inv/InvManager/XJToMLXYPartPrice",
                    },
                ],
              },
              {
                //标准成本
                label: this.$t("getapi[1973]"),
                icon: "video-play",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "93|206|207",
                  1
                ),
                children: [
                  {
                    //标准成本管理
                    path: "/standcostview",
                    name: "standcostview",
                    label: this.$t("getapi[987]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 93, 1),
                    url: "menu1/Inv/standcost/standcostview",
                  },
                  {
                    //标准成本申请一览
                    path: "/standcostapply",
                    name: "standcostapply",
                    label: this.$t("getapi[6552]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 206, 1),
                    url: "menu1/Inv/standcost/standcostapply",
                  },
                  {
                    //标准成本申请概览
                    path: "/standcostapplyview",
                    name: "standcostapplyview",
                    label: this.$t("getapi[6553]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 206, 1),
                    url: "menu1/Inv/standcost/standcostapplyview",
                  },

                ],
              },
            ],
          },
          {
            //销售管理
            label: this.$t("getapi[14]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[995]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "98|", 1),
                children: [
                  {
                    //客户信息一览
                    path: "/salcelient",
                    name: "salcelient",
                    label: this.$t("getapi[996]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 98, 1),
                    url: "/menu1/sales/ClientInfo",
                  },
                    {
                        //客户相关设置
                        path: "/customersetting",
                        name: "customersetting",
                        label: this.$t("getapi[12816]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 98, 1),
                        url: "/menu1/sales/customersetting",
                    },
                ],
              },
              {
                //销售件信息
                label: this.$t("getapi[998]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "100|", 1),
                children: [
                  {
                    //销售件信息一览
                    path: "/saltaskinfo",
                    name: "saltaskinfo",
                    label: this.$t("getapi[999]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 100, 1),
                    url: "/menu1/sales/task/info",
                  },
                  {
                    //销售件批量价格一览
                    path: "/saltaskprice",
                    name: "saltaskprice",
                    label: this.$t("getapi[7995]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 100, 1),
                    url: "/menu1/sales/task/price",
                  },
                  {
                    //销售价格审核
                    path: "/salepriceaudit",
                    name: "salepriceaudit",
                    label: this.$t("getapi[6554]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 518, 1),
                    url: "/menu1/sales/task/salepriceaudit",
                  },
                    {
                        //销售价格申请书审批模板
                        path: "/salepriceapplication",
                        name: "salepriceapplication",
                        label: this.$t("getapi[13148]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 518, 1),
                        url: "/menu1/sales/task/salepriceapplication",
                    },
                    {
                        //销售件相关设置
                        path: "/salepartsetting",
                        name: "salepartsetting",
                        label: this.$t("getapi[12632]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 100, 1),
                        url: "/menu1/sales/task/salepartsetting",
                    },
                ],
              },
              {
                //销售订单
                label: this.$t("getapi[452]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "102|103|118|104",
                  1
                ),
                children: [
                  // 销售管理-销售订单-一览
                  {
                    label: this.$t("getapi[1001]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 102, 1),
                    url: "menu1/sales/order/orderlist",
                    path: "/salorderlist",
                    name: "salorderlist",
                  },
                  // 销售管理-销售订单-明细概览
                  {
                    label: this.$t("getapi[1002]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 103, 1),
                    url: "menu1/sales/order/orderdetaillist",
                    path: "/salorderdetaillist",
                    name: "salorderdetaillist",
                  },
                  {
                    label: this.$t("getapi[8046]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 103, 1),
                    url: "menu1/sales/order/orderhistorystatus",
                    path: "/orderhistorystatus",
                    name: "orderhistorystatus",
                  },

                    // 销售管理-销售订单导入(费用)
                    {
                        label: this.$t("getapi[7778]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 102, 1),
                        url: "menu1/sales/order/orderimport",
                        path: "/orderimport",
                        name: "orderimport",
                    },
                    // 销售管理-销售订单批量关闭
                    {
                        label: this.$t("getapi[8954]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 102, 1),
                        url: "menu1/sales/order/orderbatchclose",
                        path: "/orderbatchclose",
                        name: "orderbatchclose",
                    },
                  // 销售管理-销售订单-订单费用概览
                  {
                    path: "/salordercostlist",
                    name: "salordercostlist",
                    label: this.$t("getapi[1003]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 103, 1),
                    url: "menu1/sales/order/costlist",
                  },
                  // 销售管理-销售订单-承诺即使交付率
                  {
                    path: "/salorderrate",
                    name: "salorderrate",
                    label: this.$t("getapi[1005]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 118, 1),
                    url: "menu1/sales/order/ratefile",
                  },
                  // 销售管理-销售订单-销售订单明细批量修改
                  {
                    path: "/salorderchange",
                    name: "salorderchange",
                    label: this.$t("getapi[6555]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 483, 1),
                    url: "menu1/sales/order/filechange",
                  },
                  // 销售管理-销售级零件号追溯
                  {
                    label: this.$t("getapi[13628]"),
                    icon: "arrow-right",
                    chb: false,
                    visible:true,// this.$limits.menuvisible("plv2", 102, 1),
                    url: "menu1/sales/order/saleslevparttrac",
                    path: "/saleslevparttrac",
                    name: "saleslevparttrac",
                  },
                ],
              },
              {
                //发货管理
                label: this.$t("getapi[1006]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "105|107|108|109",
                  1
                ),
                children: [
                  // 销售管理-发货管理-发货通知一览
                  {
                    path: "/salshipmentsinform",
                    name: "salshipmentsinform",
                    label: this.$t("getapi[2822]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 105, 1),
                    url: "menu1/sales/shipments/inform",
                  },
                  // 销售管理-发货管理-通知明细一览
                  {
                    path: "/salshipmentsinformedit",
                    name: "salshipmentsinformedit",
                    label: this.$t("getapi[1008]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 107, 1),
                    url: "menu1/sales/shipments/informedit",
                  },
                  // 销售管理-发货管理-发货单一览
                  {
                    path: "/salshipmentslist",
                    name: "salshipmentslist",
                    label: this.$t("getapi[1009]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 108, 1),
                    url: "menu1/sales/shipments/list",
                  },
                  // 销售管理-发货管理-发货单明细一览
                  {
                    path: "/salshipmentsinformdetail",
                    name: "salshipmentsinformdetail",
                    label: this.$t("getapi[1010]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 109, 1),
                    url: "menu1/sales/shipments/informdetail",
                  },
                  // 销售管理-发货管理-发货通知导入
                  {
                    path: "/dnimport",
                    name: "dnimport",
                    label: this.$t("getapi[1014]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 106, 1),
                    url: "menu1/sales/shipments/dnimport",
                  },
                  // 销售管理-发货管理-发货通知导入（客户订单号）
                  {
                    path: "/dnimport_no",
                    name: "dnimport_no",
                    label: this.$t("getapi[6556]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 106, 1),
                    url: "menu1/sales/shipments/dnimport_no",
                  },
                  // 销售管理-发货管理-发货通知导入新
                  {
                    path: "/dnimportnew",
                    name: "dnimportnew",
                    label: this.$t("getapi[6557]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 106, 1),
                    url: "menu1/sales/shipments/dnimportnew",
                  },
                  // 销售管理-发货管理-发货单开单
                  // {
                  // 	path: '/salshipmentsbill',
                  // 	name: 'salshipmentsbill',
                  // 	label: this.$t('getapi[1011]'),
                  // 	icon: 'arrow-right',
                  // 	chb: false,visible:true,
                  // 	url: 'menu1/sales/shipments/bill'
                  // }
                  /* // 销售管理-发货管理-装箱单一览
                                          {
                                              path: '/salshipmentspack',
                                              name: 'salshipmentspack',
                                              label: this.$t('getapi[1012]'),
                                              icon: 'arrow-right',
                                              chb: false,visible:true,
                                              url: 'menu1/sales/shipments/packlist'
                                          },
                                          // 销售管理-发货管理-装箱单概览
                                          {
                                              path: '/salshipmentspackdetail',
                                              name: 'salshipmentspackdetail',
                                              label: this.$t('getapi[1013]'),
                                              icon: 'arrow-right',
                                              chb: false,visible:true,
                                              url: 'menu1/sales/shipments/packdetail'
                                          },
                                          // 销售管理-发货管理-发货通知导入
                                          {
                                              path: '/salshipmentsinfomimp',
                                              name: 'salshipmentsinfomimp',
                                              label: this.$t('getapi[1014]'),
                                              icon: 'arrow-right',
                                              chb: false,visible:true,
                                              url: 'menu1/sales/shipments/informimp'
                                          } */
                ],
              },
              {
                //销售账务
                label: this.$t("getapi[1015]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "120|122|117", 1),
                children: [
                  // 销售管理-销售账务-开票明细总览
                  {
                    path: "/salaccoountinvoice",
                    name: "salaccoountinvoice",
                    label: this.$t("getapi[1016]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 120, 1),
                    url: "menu1/sales/accounting/invoice",
                  },
                  // 销售管理-销售账务-销售月统计
                  {
                    path: "/salaccoountmonchart",
                    name: "salaccoountmonchart",
                    label: this.$t("getapi[1017]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 122, 1),
                    url: "menu1/sales/accounting/monchart",
                  },
                  // 销售管理-销售账务-未开票其他数据统计
                  {
                    path: "/salaccoountnotinvoicother",
                    name: "salaccoountnotinvoicother",
                    label: this.$t("getapi[1018]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 117, 1),
                    url: "menu1/sales/accounting/notinvoicother",
                  },
                  // 销售管理-销售账务-未开票数据统计
                  {
                    path: "/salaccoountnotinvoice",
                    name: "salaccoountnotinvoice",
                    label: this.$t("getapi[1019]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 117, 1),
                    url: "menu1/sales/accounting/notinvoice",
                  },
                  // 销售管理-销售账务-售后价订单统计一览
                  {
                      path: "/afterprice",
                      name: "afterprice",
                      label: this.$t("getapi[13449]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: this.$limits.menuvisible("plv2", 604, 1),
                      url: "menu1/sales/accounting/afterprice",
                  },
                ],
              },
              {
                //销售价格
                label: this.$t("getapi[1020]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "123|", 1),
                children: [
                  // 销售管理-销售价格-销售价格一览
                  {
                    label: this.$t("getapi[1021]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 123, 1),
                    url: "menu1/sales/price/list",
                    path: "/salprice",
                    name: "salprice",
                  },
                  // 销售管理-销售价格-销售价格不可用设置
                  {
                    label: this.$t("getapi[12760]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 123, 1),
                    url: "menu1/sales/price/salinvalidsetting",
                    path: "/salinvalidsetting",
                    name: "salinvalidsetting",
                  },
                  // 销售管理-销售价格-销售价格批量冻结
                  {
                    label: this.$t("getapi[12905]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv4", 589, 1),
                    url: "menu1/sales/price/salepricetsetting",
                    path: "/salepricetsetting",
                    name: "salepricetsetting",
                  },
                ],
              },
              {
                //委托销售
                label: this.$t("getapi[1023]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "127|367|373|375|381|382", 1),
                children: [
                  // 发出物流一览
                  {
                    label: this.$t("getapi[1028]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 373, 1),
                    url: "menu1/sales/wt/sendexpress",
                    path: "/sendexpress",
                    name: "sendexpress",
                  },
                  // 发出物流一览
                  {
                    label: this.$t("getapi[1029]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 375, 1),
                    url: "menu1/sales/wt/csvview",
                    path: "/csvview",
                    name: "csvview",
                  },
                  // CSV收款明细一览
                  {
                      label: this.$t("getapi[8240]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "menu1/sales/wt/csvreceivables",
                      path: "/csvreceivables",
                      name: "csvreceivables",
                  },
                  // CSV收款明细导入
                  {
                      label: this.$t("getapi[8241]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "menu1/sales/wt/csvreceivablesimp",
                      path: "/csvreceivablesimp",
                      name: "csvreceivablesimp",
                  },
                  // 发出物流一览
                  {
                    label: this.$t("getapi[1030]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 381, 1),
                    url: "menu1/sales/wt/expressview",
                    path: "/expressview",
                    name: "expressview",
                  },
                    // 物流事务批量导入
                    {
                        label: this.$t("getapi[8182]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 381, 1),
                        url: "menu1/sales/wt/expressimport",
                        path: "/expressimport",
                        name: "expressimport",
                    },
                  // 发出物流一览
                  {
                    label: this.$t("getapi[1031]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 382, 1),
                    url: "menu1/sales/wt/expresstotal",
                    path: "/expresstotal",
                    name: "expresstotal",
                  },
                    // 销售明细表汇总
                    {
                        label: this.$t("getapi[7936]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 548, 1),
                        url: "menu1/sales/wt/saleinfo",
                        path: "/saleinfo",
                        name: "saleinfo",
                    },
                    // 外仓库存调整单导入
                    {
                        label: this.$t("getapi[9904]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: false,
                        url: "menu1/sales/wt/saltruinfoimp",
                        path: "/saltruinfoimp",
                        name: "saltruinfoimp",
                    },
                    // 发出商品明细表汇总
                    {
                        label: this.$t("getapi[7953]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 550, 1),
                        url: "menu1/sales/wt/sendproductinfo",
                        path: "/sendproductinfo",
                        name: "sendproductinfo",
                    },
                    // 收发存汇总
                    {
                        label: this.$t("getapi[7964]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 552, 1),
                        url: "menu1/sales/wt/rdinfo",
                        path: "/rdinfo",
                        name: "rdinfo",
                    },
                ],
              },
              {
                //发货预测管理
                label: this.$t("getapi[12352]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "571|572", 1),
                children: [
                  // 发货预测管理
                  {
                    label: this.$t("getapi[12352]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 571, 1),
                    url: "menu1/sales/forecast/forecastimport",
                    path: "/forecastimport",
                    name: "forecastimport",
                  },
                  // 运输时长配置
                  {
                    label: this.$t("getapi[12353]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 572, 1),
                    url: "menu1/sales/forecast/trantimeconfig",
                    path: "/trantimeconfig",
                    name: "trantimeconfig",
                  },
                ],
              },
            ],
          },

          {
            label: this.$t("getapi[13]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[1032]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "130|128|147|129|343|326",
                  1
                ),
                children: [
                  {
                    path: "/wxprice",
                    name: "wxprice",
                    label: this.$t("getapi[1033]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 128, 1),
                    url: "menu1/wx/wxprice",
                  },
                    {
                        path: "/wxbatchoverview",
                        name: "wxbatchoverview",
                        label: this.$t("getapi[8173]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 128, 1),
                        url: "menu1/wx/wxbatchoverview",
                    },
                  {
                    path: "/dsxwxprice",
                    name: "dsxwxprice",
                    label: this.$t("getapi[6558]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 128, 1),
                    url: "menu1/wx/dsxwxprice",
                  },
                  {
                    path: "/countprice",
                    name: "countprice",
                    label: this.$t("getapi[1034]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 506, 1),
                    url: "menu1/wx/countprice",
                  },
                  {
                    path: "/wxpricebatchupdate",
                    name: "wxpricebatchupdate",
                    label: this.$t("getapi[6559]"),
                    //label: '通用导入',
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 507, 1),
                    url: "/menu1/wx/wxpricebatchupdate",
                  },
                  // {
                  //   path: "/exp27/27",
                  //   name: "exp27",
                  //   label: this.$t("getapi[8217]"),
                  //   icon: "arrow-right",
                  //   chb: false,
                  //   visible: this.$limits.menuvisible("plv2", 507, 1),
                  //   params: {
                  //     id: 27,
                  //   },
                  //   url: "/exp27/27",
                  // },
                  {
                    path: "/wxhprice",
                    name: "wxhprice",
                    label: this.$t("getapi[1036]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 343, 1),
                    url: "menu1/wx/wxhprice",
                  },

                  {
                    path: "/wparicechart",
                    name: "wparicechart",
                    label: this.$t("getapi[91]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 326, 1),
                    url: "/wparicechart",
                  },
                    {
                        //外协价格请示书管理
                        path: "/wxpricereq",
                        name: "wxpricereq",
                        label: this.$t("getapi[6561]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 521, 1),
                        url: "/menu1/wx/wxpricereq",
                    },
                    {
                        //外协价格申请书概览
                        path: "/wxpricedetail",
                        name: "wxpricedetail",
                        label: this.$t("getapi[8197]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 521, 1),
                        url: "/menu1/wx/wxpricedetail",
                    },
                    {
                        //外协价格申请书审批
                        path: "/wxpricereqapprove",
                        name: "wxpricereqapprove",
                        label: this.$t("getapi[6562]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 523, 1),
                        url: "/menu1/wx/wxpricereqapprove",
                    },
                    {
                        //外协价格申请书审批模板
                        path: "/wxpriceapplication",
                        name: "wxpriceapplication",
                        label: this.$t("getapi[6563]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 524, 1),
                        url: "/menu1/wx/wxpriceapplication",
                    },
                    {
                        //外协工序基础价格
                        path: "/wxroutingprice",
                        name: "wxroutingprice",
                        label: this.$t("getapi[7923]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 523, 1),
                        url: "/menu1/wx/wxroutingprice",
                    },
                ],
              },

              {
                label: this.$t("getapi[1038]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "130|131", 1),
                children: [
                  {
                    path: "/wxorder/root",
                    name: "wxorder",
                    label: this.$t("getapi[1039]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 130, 1),
                    params: {
                      id: "root",
                    },
                    url: "menu1/wx/wxorder",
                  },
                  {
                    path: "/wxorderdetail",
                    name: "wxorderdetail",
                    label: this.$t("getapi[1040]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 130, 1),
                    url: "menu1/wx/wxorderdetail",
                  },
                  {
                      path: "/issfaview",
                      name: "issfaview",
                      label: this.$t("getapi[13528]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "menu1/wx/issfaview",
                  },
                  {
                    path: "/wxplantrans",
                    name: "wxplantrans",
                    label: this.$t("getapi[1042]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 484, 1),
                    url: "menu1/wx/wxplantrans",
                  },
                ],
              },

              {
                label: this.$t("getapi[1043]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "132|133", 1),
                children: [
                  {
                    path: "/issueoutview",
                    name: "issueoutview",
                    label: this.$t("getapi[1044]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 132, 1),
                    url: "wx/issueoutview",
                  },
                  {
                    path: "/issueoutdetail",
                    name: "issueoutdetail",
                    label: this.$t("getapi[1045]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 132, 1),
                    url: "wx/issueoutdetail",
                  },
                ],
              },

              {
                label: this.$t("getapi[1047]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "134|135", 1),
                children: [
                  {
                    path: "/issueregistview",
                    name: "issueregistview",
                    label: this.$t("getapi[1048]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 134, 1),
                    url: "wx/issueregistview",
                  },
                  {
                    path: "/issueregistdetail",
                    name: "issueregistdetail",
                    label: this.$t("getapi[1050]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 134, 1),
                    url: "wx/issueregistdetail",
                  },
                ],
              },
              {
                label: this.$t("getapi[6564]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "140|141", 1),
                children: [
                  {
                    path: "/issuereceiveview",
                    name: "issuereceiveview",
                    label: this.$t("getapi[1052]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 140, 1),
                    url: "wx/issuereceiveview",
                  },
                  {
                    path: "/issuereceivedetail",
                    name: "issuereceivedetail",
                    label: this.$t("getapi[1053]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 140, 1),
                    url: "wx/issuereceivedetail",
                  },
                    {
                        path: "/issuereceiveserial",
                        name: "issuereceiveserial",
                        label: this.$t("getapi[8181]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 140, 1),
                        url: "wx/issuereceiveserial",
                    },
                ],
              },
              {
                label: this.$t("getapi[1055]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "130|151|152", 1),
                children: [
                  {
                    //外协及时交付率
                    path: "/wxrateview",
                    name: "wxrateview",
                    label: this.$t("getapi[6565]"),
                    icon: "caret-right",
                    chb: false,
                    visible: true,
                    url: "menu1/wx/wxrateview",
                  },
                  {
                    path: "/wxsfc",
                    name: "wxsfc",
                    label: this.$t("getapi[1056]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 130, 1),
                    url: "menu1/wx/wxsfc",
                  },
                  {
                    path: "/fwdd",
                    name: "fwdd",
                    label: this.$t("getapi[1057]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 130, 1),
                    url: "menu1/wx/fwdd",
                  },
                  {
                    path: "/wxwkp",
                    name: "wxwkp",
                    label: this.$t("getapi[1058]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 151, 1),
                    url: "menu1/wx/wxwkp",
                  },
                  {
                    path: "/wxxq",
                    name: "wxxq",
                    label: this.$t("getapi[6566]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 485, 1),
                    url: "menu1/wx/wxxq",
                  },
                  {
                    path: "/cbzj",
                    name: "cbzj",
                    label: this.$t("getapi[6567]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 486, 1),
                    url: "menu1/wx/cbzj",
                  },
                  {
                    path: "/wxlz",
                    name: "wxlz",
                    label: this.$t("getapi[1060]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 152, 1),
                    url: "menu1/wx/wxlz",
                  },
                    {
                        //外协件年度采购金额统计
                        path: "/wxacquisition",
                        name: "wxacquisition",
                        label: this.$t("getapi[6568]"),
                        icon: "caret-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 128, 1),
                        url: "menu1/wx/wxacquisition",
                    },
                ],
              },
            ],
          },

          /*{
                              label: this.$t('getapi[15]'),
                              icon: 'video-play',
                              chb: true,visible:true,
                              children: [
                                  {
                                      path: '/page1',
                                      name: 'page1',
                                      label: '页面1',
                                      icon: 'caret-right',
                                      chb: false,visible:true,
                                      url: 'Other/PageOne'
                                  }
                              ]
                          },*/
          {
            //系统管理
            label: this.$t("getapi[12]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //通用基础信息
                label: this.$t("getapi[1061]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible(
                  "plv2",
                  "1|2|199|3|5|246",
                  1
                ),
                children: [
                  {
                    //公司基本信息
                    path: "/company",
                    name: "company",
                    label: this.$t("getapi[1062]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 1, 1),
                    url: "menu1/sys/basicinfo/company",
                  },
                  {
                    //部门信息
                    path: "/department",
                    name: "department",
                    label: this.$t("getapi[1063]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 2, 1),
                    url: "menu1/sys/basicinfo/department",
                  },
                  {
                    //领料部门信息
                    path: "/ssyIssuedeptinfo",
                    name: "ssyIssuedeptinfo",
                    label: this.$t("getapi[6042]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 199, 1),
                    url: "menu1/sys/basicinfo/ssyIssuedeptinfo",
                  },
                  {
                    //岗位信息
                    path: "/postinfo",
                    name: "postinfo",
                    label: this.$t("getapi[1064]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 3, 1),
                    url: "menu1/sys/basicinfo/postinfo",
                  },
                  {
                    //配置信息
                    path: "/config",
                    name: "config",
                    label: this.$t("getapi[1067]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 5, 1),
                    url: "menu1/sys/basicinfo/config",
                  },
                  {
                    //单据编号
                    path: "/ordinal",
                    name: "ordinal",
                    label: this.$t("getapi[4468]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "menu1/sys/basicinfo/ordinal",
                  },
                  {
                    //报表管理
                    path: "/report",
                    name: "report",
                    label: this.$t("getapi[1068]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 5, 1),
                    url: "menu1/sys/basicinfo/report",
                  },
                  {
                    //跟踪历史
                    path: "/trace",
                    name: "trace",
                    label: this.$t("getapi[6054]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 246, 1),
                    url: "menu1/sys/basicinfo/trace",
                  },
                    {
                        //预警设置
                        path: "/remindrule",
                        name: "remindrule",
                        label: this.$t("getapi[2547]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 377, 1),
                        url: "menu1/sys/basicinfo/remindrule",
                    },
                  {
                    //系统升级历史
                    path: "/updatehistory",
                    name: "updatehistory",
                    label: this.$t("getapi[6569]"),
                    icon: "arrow-right",
                    chb: false,
                    visible:true,
                    url: "menu1/sys/basicinfo/updatehistory",
                  },
                    {
                        //翻译
                        path: "/translation",
                        name: "translation",
                        label: this.$t("getapi[8078]"),
                        icon: "arrow-right",
                        chb: false,
                        visible:this.$limits.menuvisible("plv2", 10, 1),//和用户权限设置一个权限
                        url: "menu1/sys/basicinfo/translation",
                    },
                    {
                        //模板配置
                        path: "/templateconfig",
                        name: "templateconfig",
                        label: this.$t("getapi[8076]"),
                        icon: "arrow-right",
                        chb: false,
                        visible:true,
                        url: "menu1/sys/basicinfo/templateconfig",
                    },
                    {
                        //纸张配置
                        path: "/paperconfig",
                        name: "paperconfig",
                        label: this.$t("getapi[8077]"),
                        icon: "arrow-right",
                        chb: false,
                        visible:true,
                        url: "menu1/sys/basicinfo/paperconfig",
                    },
                    {
                        //附件路径配置
                        path: "/filesconfig",
                        name: "filesconfig",
                        label: this.$t("getapi[8056]"),
                        icon: "arrow-right",
                        chb: false,
                        visible:true,
                        url: "menu1/sys/basicinfo/filesconfig",
                    },
                    {
                        //模块-说明文档
                        path: "/modelhelp",
                        name: "modelhelp",
                        label:this.$t("getapi[13349]"),
                        icon: "arrow-right",
                        chb: false,
                        visible:true,
                        url: "menu1/sys/basicinfo/modelhelp",
                    },
                    // {
                    //   //拆分表业务
                    //   path: "/splittbale",
                    //   name: "splittbale",
                    //   label: this.$t("getapi[13028]"),
                    //   icon: "arrow-right",
                    //   chb: false,
                    //   visible: true,//this.$limits.menuvisible("plv2", 1, 1),
                    //   url: "menu1/sys/basicinfo/splittbale",
                    // },
                  /*{
                      //列头排序
                      path: "/colsort",
                      name: "colsort",
                      label: '列头排序',
                      icon: "arrow-right",
                      chb: false,
                      visible: true,12307
                      url: "menu1/sys/basicinfo/colsort",
                  },*/
                ],
              },
              {
                //用户及权限管理
                label: this.$t("getapi[1069]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "4|7|10", 1),
                children: [
                  {
                    //人员一览
                    path: "/sysemployee",
                    name: "sysemployee",
                    label: this.$t("getapi[1065]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 4, 1),
                    url: "menu1/sys/basicinfo/employee",
                  },
                  {
                    //用户信息一览
                    path: "/userview",
                    name: "userview",
                    label: this.$t("getapi[1070]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 7, 1),
                    url: "menu1/sys/usersandpermissions/userview",
                  },
                  // {
                  //   //用户权限项管理
                  //   path: "/dblv",
                  //   name: "dblv",
                  //   label: this.$t("getapi[6570]"),
                  //   icon: "arrow-right",
                  //   chb: false,
                  //   visible: this.$limits.menuvisible("plv2", 8, 1),
                  //   url: "menu1/sys/usersandpermissions/dblv",
                  // },
                  {
                    //角色权限设置
                    path: "/roleauthorityset",
                    name: "roleauthorityset",
                    label: this.$t("getapi[1072]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 501, 1),
                    url: "menu1/sys/usersandpermissions/roleauthorityset",
                  },
         /*           {
                        //角色权限设置
                        path: "/roleauthorityset_test",
                        name: "roleauthorityset_test",
                        label: this.$t("getapi[1072]")+ '测试',
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 501, 1),
                        url: "menu1/sys/usersandpermissions/roleauthorityset_test",
                    },*/
                  {
                    //用户权限设置
                    path: "/userauthorityset",
                    name: "userauthorityset",
                    label: this.$t("getapi[1073]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 10, 1),
                    url: "menu1/sys/usersandpermissions/userauthorityset",
                  },
             /*       {
                        //用户权限设置
                        path: "/userauthorityset_test",
                        name: "userauthorityset_test",
                        label: this.$t("getapi[1073]") + '测试',
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 10, 1),
                        url: "menu1/sys/usersandpermissions/userauthorityset_test",
                    },*/
                  {
                    //权限授权及查询
                    path: "/authoritysearch",
                    name: "authoritysearch",
                    label: this.$t("getapi[1075]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 10, 1),
                    url: "menu1/sys/usersandpermissions/authoritysearch",
                  },
           /*         {
                        //权限授权及查询
                        path: "/authoritysearch_test",
                        name: "authoritysearch_test",
                        label: this.$t("getapi[1075]")+'测试',
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 10, 1),
                        url: "menu1/sys/usersandpermissions/authoritysearch_test",
                    },*/
                ],
              },
              {
                label: this.$t("getapi[1076]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "7|", 1),
                children: [
                  {
                    //在线用户一览
                    path: "/useronline",
                    name: "useronline",
                    label: this.$t("getapi[1077]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 7, 1),
                    url: "menu1/sys/useronlinemanage/useronline",
                  },
                  {
                    //登录历史一览
                    path: "/loginhistory",
                    name: "loginhistory",
                    label: this.$t("getapi[1078]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 7, 1),
                    url: "menu1/sys/useronlinemanage/loginhistory",
                  },
                ],
              },
            ],
          },
          {
            //基础信息
            label: this.$t("getapi[11]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //通用字典信息
                label: this.$t("getapi[1079]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.menuvisible("plv2", 6, 1),
                children: [
                  {
                    path: "/uni",
                    name: "uni",
                    label: this.$t("getapi[888]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "basic/uni",
                  },
                  {
                    path: "/region",
                    name: "region",
                    label: this.$t("getapi[1080]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "basic/region",
                  },
                  {
                    path: "/bank",
                    name: "bank",
                    label: this.$t("getapi[1081]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "basic/bank",
                  },
                  {
                    path: "/country",
                    name: "country",
                    label: this.$t("getapi[1084]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "basic/country",
                  },
                  {
                    path: "/exchange",
                    name: "exchange",
                    label: this.$t("getapi[1083]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "basic/exchange",
                  },
                  {
                    path: "/paytype",
                    name: "paytype",
                    label: this.$t("getapi[1082]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "basic/paytype",
                  },
                  {
                    path: "/rateslist",
                    name: "rateslist",
                    label: this.$t("getapi[1085]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "basic/rateslist",
                  },
                    {
                        path: "/currencycodelist",
                        name: "currencycodelist",
                        label: this.$t("getapi[8238]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "basic/currencycodelist",
                    },
                ],
              },
              {
                //基础信息-项目基础信息
                label: this.$t("getapi[1086]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.menuvisible("plv2", 26, 1),
                children: [
                  {
                    path: "/wcenter",
                    name: "wcenter",
                    label: this.$t("getapi[3083]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/items/wcenter",
                  },
                  {
                    path: "/processt",
                    name: "processt",
                    label: this.$t("getapi[3084]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/items/processt",
                  },
                  {
                    path: "/itemprotype",
                    name: "itemprotype",
                    label: this.$t("getapi[1088]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/items/itemprotype",
                  },
                  {
                    path: "/itemfinnacetype",
                    name: "itemfinnacetype",
                    label: this.$t("getapi[1089]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/items/itemfinnacetype",
                  },
                  {
                    path: "/itemcommondittype",
                    name: "itemcommondittype",
                    label: this.$t("getapi[1090]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/items/itemcommondittype",
                  },
                  {
                    path: "/itemprolist",
                    name: "itemprolist",
                    label: this.$t("getapi[1091]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/items/itemprolist",
                  },
                  {
                    //存货类别
                    path: "/category",
                    name: "category",
                    label: this.$t("getapi[1092]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 393, 1),
                    url: "/items/category",
                  },
                ],
              },
              {
                //基础信息-供应商开发基础信息
                label: this.$t("getapi[1093]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.menuvisible("plv2", 41, 1),
                children: [
                  {
                    path: "/supplytype",
                    name: "supplytype",
                    label: this.$t("getapi[1094]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/supplybase/supplytype",
                  },
                  {
                    path: "/supplygrade",
                    name: "supplygrade",
                    label: this.$t("getapi[1095]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/supplybase/supplygrade",
                  },
                  {
                    path: "/purparttype",
                    name: "purparttype",
                    label: this.$t("getapi[1096]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/supplybase/purparttype",
                  },
                  {
                    path: "/venimport",
                    name: "venimport",
                    label: this.$t("getapi[1097]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/supplybase/venimport",
                  },
                    {
                        path: "/deliverymodel",
                        name: "deliverymodel",
                        label: this.$t("getapi[1101]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "/purchasebasic/deliverymodel",
                    },
                    {
                        path: "/purposition",
                        name: "purposition",
                        label: this.$t("getapi[1103]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "/purchasebasic/purposition",
                    },
                    {
                        path: "/transmodel",
                        name: "transmodel",
                        label: this.$t("getapi[1106]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "/purchasebasic/transmodel",
                    },
                ],
              },
              {
                //基础信息-采购基础信息
                label: this.$t("getapi[1098]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.menuvisible("plv2", 56, 1),
                children: [
                  {
                    path: "/purmodel",
                    name: "purmodel",
                    label: this.$t("getapi[1100]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/purchasebasic/purmodel",
                  },
                  {
                    path: "/purgroup",
                    name: "purgroup",
                    label: this.$t("getapi[1102]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/purchasebasic/purgroup",
                  },
                  /*{
                    path: "/invoicetype",
                    name: "invoicetype",
                    label: this.$t("getapi[1104]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/purchasebasic/invoicetype",
                  },*/
                  {
                    path: "/checkstd",
                    name: "checkstd",
                    label: this.$t("getapi[1105]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/purchasebasic/checkstd",
                  },
                  {
                    path: "/puroverchageconfig",
                    name: "puroverchageconfig",
                    label: this.$t("getapi[12650]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/purchasebasic/puroverchageconfig",
                  },
                  // {
                  //   path: "/purodersendemailconfig",
                  //   name: "purodersendemailconfig",
                  //   label: this.$t("getapi[13089]"),
                  //   icon: "arrow-right",
                  //   chb: false,
                  //   visible: true,
                  //   url: "/purchasebasic/purodersendemailconfig",
                  // },
                ],
              },
              {
                //基础信息-仓库基础信息
                label: this.$t("getapi[1107]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.menuvisible("plv2", 76, 1),
                children: [
                  {
                    path: "/cargogroup",
                    name: "cargogroup",
                    label: this.$t("getapi[1108]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 76, 1),
                    url: "/wh/cargogroup",
                  },
                  {
                    path: "/cargoposition",
                    name: "cargoposition",
                    label: this.$t("getapi[3404]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 76, 1),
                    url: "/wh/cargoposition",
                  },
                  {
                      path: "/cargotype",
                      name: "cargotype",
                      label: this.$t("getapi[8189]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "/wh/cargotype",
                  },
                  {
                    path: "/sysconfig",
                    name: "sysconfig",
                    label: this.$t("getapi[1109]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 91, 1),
                    url: "/wh/sysconfig",
                  },
                ],
              },
              {
                //基础信息-销售基础信息
                label: this.$t("getapi[1110]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.menuvisible("plv2", 97, 1),
                children: [
                  //基础信息-销售运输方式
                  {
                    path: "/transport",
                    name: "transport",
                    label: this.$t("getapi[1111]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/transpor",
                  },

                  //基础信息-销售包装方式
                  {
                    path: "/puck",
                    name: "puck",
                    label: this.$t("getapi[1112]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/puck",
                  },
                  //基础信息-销售类别
                  {
                    path: "/saltype",
                    name: "saltype",
                    label: this.$t("getapi[1113]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/saltype",
                  },
                  //基础信息-合同类别
                  {
                    path: "/contract",
                    name: "contract",
                    label: this.$t("getapi[1647]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/contract",
                  },
                  //基础信息-原因信息
                  {
                    path: "/reason",
                    name: "reason",
                    label: this.$t("getapi[6571]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/reason",
                  },
                  //基础信息-运输方信息
                  {
                    path: "/transporter",
                    name: "transporter",
                    label: this.$t("getapi[6572]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/transporter",
                  },
                  //基础信息-客户类型
                  {
                    path: "/customertype",
                    name: "customertype",
                    label: this.$t("getapi[1114]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/customertype",
                  },
                  //基础信息-客户分组
                  {
                    path: "/customergroup",
                    name: "customergroup",
                    label: this.$t("getapi[1115]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/customergroup",
                  },
                  //基础信息-交货条款
                  {
                    path: "/deliveryterm",
                    name: "deliveryterm",
                    label: this.$t("getapi[1116]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/deliveryterm",
                  },
                  //基础信息-员工项目对照管理
                  {
                    path: "/employeesal",
                    name: "employeesal",
                    label: this.$t("getapi[1117]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "/sal/employee",
                  },
                    //基础信息-新品研发客户关系
                    {
                        path: "/cusitemrelation",
                        name: "cusitemrelation",
                        label: this.$t("getapi[12925]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "/sal/cusitemrelation",
                    },
                ],
              },
              {
                //基础信息-生产基础信息
                label: this.$t("getapi[1118]"),
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  //基础信息-生产配置
                  {
                    path: "/proconfig",
                    name: "proconfig",
                    label: this.$t("getapi[1119]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 165, 1),
                    url: "/pro/proconfig",
                  },
                  //基础信息-生产配置
                  {
                    path: "/prodautoconfig",
                    name: "prodautoconfig",
                    label: this.$t("getapi[13490]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 165, 1),
                    url: "/pro/prodautoconfig",
                  },
                  

                  //基础信息-车间货位
                  {
                    path: "/proshopposition",
                    name: "proshopposition",
                    label: this.$t("getapi[1120]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 162, 1),
                    url: "/pro/proshopposition",
                  },
                  //基础信息-车间组别
                  {
                    path: "/proshopgroup",
                    name: "proshopgroup",
                    label: this.$t("getapi[1121]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 162, 1),
                    url: "/pro/proshopgroup",
                  },
                  //基础信息-SR类别
                  {
                    path: "/prosrtype",
                    name: "prosrtype",
                    label: this.$t("getapi[1122]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 163, 1),
                    url: "/pro/prosrtype",
                  },
                  //基础信息-员工与工作中心对照表
                  {
                    path: "/proemployeeworkcenter",
                    name: "proemployeeworkcenter",
                    label: this.$t("getapi[6573]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 395, 1),
                    url: "/pro/proemployeeworkcenter",
                  },
                  //基础信息-员工与库区对照表
                  {
                    path: "/areauser",
                    name: "areauser",
                    label: this.$t("getapi[6574]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 396, 1),
                    url: "/pro/areauser",
                  },
                    //基础信息-员工与领料部门、班组长、生产计划对照表
                    {
                        path: "/employeerelation",
                        name: "employeerelation",
                        label: this.$t("getapi[8194]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 397, 1),
                        url: "/pro/employeerelation",
                    },
                    //基础信息-返工配置
                    {
                        path: "/prorepair",
                        name: "prorepair",
                        label: this.$t("getapi[12794]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 511, 1),
                        url: "/pro/prorepair",
                    },
                ],
              },
              {
                //基础信息-财务基础信息
                label: this.$t("getapi[1123]"),
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  //基础信息-财务配置信息
                  {
                    path: "/financeconfig",
                    name: "financeconfig",
                    label: this.$t("getapi[1124]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 210, 1),
                    url: "/finance/financeconfig",
                  },
                    //基础信息-节假日信息
                    {
                        path: "/sysholiday",
                        name: "sysholiday",
                        label: this.$t("getapi[8236]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "/finance/sysholiday",
                    },
                    //基础信息-本单位银行账号
                    {
                        path: "/bankaccount",
                        name: "bankaccount",
                        label: this.$t("getapi[13378]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "/finance/bankaccount",
                    },
                    //基础信息-结算方式
                    {
                        path: "/billingoptions",
                        name: "billingoptions",
                        label: this.$t("getapi[1228]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "/finance/billingoptions",
                    },
                ],
              },
            ],
          },
          {
            //文档管理
            label: this.$t("getapi[79]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                path: "/docmanageview",
                name: "docmanageview",
                label: this.$t("getapi[6575]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 394, 1),
                url: "menu1/docmanage/docmanageview",
              },
              {
                path: "/foreigndocview",
                name: "foreigndocview",
                label: this.$t("getapi[12669]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 394, 1),
                url: "menu1/docmanage/foreigndocview",
              },
              {
                path: "/managesysview",
                name: "managesysview",
                label: this.$t("getapi[12563]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 394, 1),
                url: "menu1/docmanage/managesysview",
              },
              {
                path: '/doc',
                name: 'doc',
                label: this.$t("getapi[6576]"),
                icon: 'arrow-right',
                chb: false,
                visible: this.$limits.menuvisible("plv2", 493, 1),
                url: 'menu1/docmanage/doc'
              },
              {
                  path: '/doclog',
                  name: 'doclog',
                  label: this.$t("getapi[12384]"),
                  icon: 'arrow-right',
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 573, 1),
                  url: 'menu1/docmanage/doclog'
              },              
              {
                  path: "/docdownload",
                  name: "docdownload",
                  label: this.$t("getapi[6111]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: true,
                  url: "menu1/docmanage/docdownload",
              },
              {
                  path: "/docnodeapproval",
                  name: "docnodeapproval",
                  label: this.$t("getapi[12695]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 581, 1),
                  url: "menu1/docmanage/docnodeapproval",
              },
                {
                    path: "/docrole",
                    name: "docrole",
                    label: this.$t("getapi[1072]"),
                    icon: "arrow-right",
                    chb: false,
                    visible:this.$limits.menuvisible("plv2", 583, 1),
                    url: "menu1/docmanage/docrole",
                },
              {
                  path: "/docemployee",
                  name: "docemployee",
                  label: this.$t("getapi[1073]"),
                  icon: "arrow-right",
                  chb: false,
                  visible:this.$limits.menuvisible("plv2", 582, 1),
                  url: "menu1/docmanage/docemployee",
              },
              /* {
                              path: '/docmanageauthority',
                              name: 'docmanageauthority',
                              label: '权限管理',
                              icon: 'arrow-right',
                              chb: false,
                              visible: true,
                              url: 'menu1/docmanage/docmanageauthority'
                          },*/
            ],
          },
          // 	]
          // },
          /* {
                      label: this.$t('getapi[19]'),
                      icon: 's-open',
                      children: [
                          {
                              path: '/page1',
                              name: 'page1',
                              label: '页面1',
                              chb: false,visible:true,
                              icon: 'video-play',
                              url: 'Other/PageOne'
                          },
                          {
                              path: '/page2',
                              name: 'page2',
                              label: '页面2',
                              chb: false,visible:true,
                              icon: 'video-play',
                              url: 'Other/PageTwo'
                          }
                      ]
                  },
                  {
                      label: this.$t('getapi[3977]'),
                      icon: 's-finance',
                      children: [
                          {
                              path: '/page1',
                              name: 'page1',
                              label: '页面1',
                              chb: false,visible:true,
                              icon: 'video-play',
                              url: 'Other/PageOne'
                          },
                          {
                              path: '/page2',
                              name: 'page2',
                              label: '页面2',
                              chb: false,visible:true,
                              icon: 'video-play',
                              url: 'Other/PageTwo'
                          },
                          {
                              path: '/exp',
                              name: 'exp',
                              chb: false,visible:true,
                              label: '导入',
                              icon: 'video-play',
                              url: '/exp/:id'
                          }
                      ]
                  } */
          {
            label: this.$t('getapi[6577]'),
            icon: 'video-play',
            chb: true,
            visible:true,
            children: [
              {
                label: this.$t('getapi[6578]'),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2","513",1),
                children: [
                  {
                    path: "/logcarview",
                    name: "logcarview",
                    label: this.$t('getapi[6579]'),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 513, 1),
                    url: "menu1/logcar/logcarview",
                  },
                ],
              },
              {
                label: this.$t('getapi[6580]'),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2","514|515|517",1),
                children: [
                  {
                    path: "/logcarshipview",
                    name: "logcarshipview",
                    label: this.$t('getapi[6581]'),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 514, 1),
                    url: "menu1/logcar/logcarshipview",
                  },
                  {
                    path: "/logcarshipviewout",
                    name: "logcarshipviewout",
                    label: this.$t('getapi[6582]'),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 515, 1),
                    url: "menu1/logcar/logcarshipviewout",
                  },
                ],
              },
              /* {
                   path: "/logairlift",
                   name: "logairlift",
                   label: "空运申请单",
                   icon: "caret-right",
                   chb: false,
                   visible: this.$limits.menuvisible("plv2", 516, 1),
                   url: "menu1/logcar/logairlift",
               },*/
              {
                //物流审批模板
                path: "/logapplication",
                name: "logapplication",
                label: this.$t('getapi[6583]'),
                icon: "caret-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 517, 1),
                url: "menu1/logcar/logapplication",
              },              
              {
                path: "/importcustoms",
                name: "importcustoms",
                label: this.$t('getapi[12968]'),
                icon: "arrow-right",
                chb: false,
                visible: true,
                url: "menu1/logcar/importcustoms",
              },
                /*{
                    //cs
                    path: "/test",
                    name: "test",
                    label: '物料位置',
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 517, 1),
                    url: "menu1/logcar/logapplication",
                },*/
                /*{
                    path: "/websocket",
                    name: "websocket",
                    label: 'websocket',
                    icon: "caret-right",
                    chb: false,
                    visible: true,
                    url: "menu1/logcar/websocket",
                },*/
            ]
          },
        ];
        this.menu2 = [
          {
            label: this.$t('getapi[7975]'),
            icon: "s-home",
            chb: false,
            visible: true,
          },
          {
            label: this.$t('getapi[19]'),
            icon: "s-home",
            chb: false,
            visible: true,
          },
          {
            label: this.$t("getapi[27]"), //日历信息
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[3980]"), //日历信息
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  {
                    path: "/calendarview",
                    name: "2_calendarview",
                    label: this.$t("getapi[3981]"), //日历一览
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 166, 1),
                    url: "calendar/calendarinfo/calendarview",
                  },
                  {
                    path: "/calendardetail",
                    name: "2_calendardetail",
                    label: this.$t("getapi[3982]"), //日历概览
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 167, 1),
                    url: "calendar/calendarinfo/calendardetail",
                  },
                ],
              },
              {
                label: this.$t("getapi[3984]"), //班次信息
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  {
                    path: "/workdayview",
                    name: "2_workdayview",
                    label: this.$t("getapi[3985]"), //日历一览
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 169, 1),
                    url: "calendar/workdayinfo/workdayview",
                  },
                  {
                    path: "/workdaydetail",
                    name: "2_workdaydetail",
                    label: this.$t("getapi[3987]"), //日历概览
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 170, 1),
                    url: "calendar/workdayinfo/workdaydetail",
                  },
                ],
              },
            ],
          },
          {
            label: this.$t("getapi[26]"), //主计划
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[3988]"), //主计划相关
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "172|173|", 1),
                children: [
                  {
                    path: "/mpsview",
                    name: "2_mpsview",
                    label: this.$t("getapi[3989]"), //主计划一览
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 172, 1),
                    url: "MPS/mpsrelate/mpsview",
                  },
                  {
                    path: "/mpsdetailview",
                    name: "2_mpsdetailview",
                    label: this.$t("getapi[3991]"), //主计划概览
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 173, 1),
                    url: "MPS/mpsrelate/mpsdetailview",
                  },
                  {
                      path: "/updatempsunitcharge",
                      name: "2_updatempsunitcharge",
                      label: this.$t("getapi[3992]"), //批量更新负荷
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "MPS/mpsrelate/updatempsunitcharge",
                  },
                ],
              },
              {
                label: this.$t("getapi[6363]"), //粗能力计算
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "175|176|", 1),
                children: [
                  {
                    path: "/mpscharge",
                    name: "2_mpscharge",
                    label: this.$t("getapi[3994]"), //粗能力清单
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 175, 1),
                    url: "MPS/mpscharge/mpscharge",
                  },
                  {
                    path: "/chargemanagedata",
                    name: "2_chargemanagedata",
                    label: this.$t("getapi[3995]"), //粗能力统计
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 176, 1),
                    url: "MPS/mpscharge/chargemanagedata",
                  },
                  {
                      path: "/actualcapacity",
                      name: "2_actualcapacity",
                      label: this.$t("getapi[13460]"), //实际产能
                      icon: "arrow-right",
                      chb: false,
                      visible: this.$limits.menuvisible("plv2", 176, 1),
                      url: "MPS/mpscharge/actualcapacity",
                  },
                ],
              },
            ],
          },
          {
            label: this.$t("getapi[25]"), //SR与SO
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[3996]"), //SR相关
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "177|", 1),
                children: [
                  {
                    path: "/srview",
                    name: "2_srview",
                    label: this.$t("getapi[3997]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 177, 1),
                    url: "SR/srview",
                  },
                ],
              },
              {
                label: this.$t("getapi[3999]"), //SO相关
                icon: "caret-right",
                chb: true,
                visible: true,//this.$limits.SecondMenuVisible("plv2", "180|113|307|164|146|247", 1),
                children: [
                  {
                    path: "/soview",
                    name: "2_soview",
                    label: this.$t("getapi[4000]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 180, 1),
                    url: "SO/soview",
                  },
                  {
                    path: "/somateril",
                    name: "2_somateril",
                    label: this.$t("getapi[4001]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 113, 1),
                    url: "SO/somateril",
                  },
                    {
                        path: "/somaterilnew",
                        name: "2_somaterilnew",
                        label: this.$t("getapi[12988]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 113, 1),
                        url: "SO/somaterilnew",
                    },
                  {
                    path: "/sopartlackmateril",
                    name: "2_sopartlackmateril",
                    label: this.$t("getapi[12529]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 579, 1),
                    url: "SO/sopartlackmateril",
                  },
                  {
                    path: "/somaterilexereport",
                    name: "2_somaterilexereport",
                    label: this.$t("getapi[10308]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 562, 1),
                    url: "SO/somaterilexereport",
                  },
                  {
                    //SO相关
                    path: "/sobatch",
                    name: "2_sobatch",
                    label: this.$t("getapi[4003]"), //SO相关
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 307, 1),
                    url: "SO/sobatch",
                  },
                  {
                    //SO层次管理
                    path: "/solevel",
                    name: "2_solevel",
                    label: this.$t("getapi[4004]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 310, 1),
                    url: "SO/solevel",
                  },
                  {
                      //SO层次管理新
                      path: "/solevelnew",
                      name: "2_solevelnew",
                      label: this.$t("getapi[4004]") + '新',
                      icon: "arrow-right",
                      chb: false,
                      visible: this.$limits.menuvisible("plv2", 310, 1),
                      url: "SO/solevelnew",
                  },
                  {
                    //缺料计算
                    path: "/lesscompute",
                    name: "2_lesscompute",
                    label: this.$t("getapi[6584]"), //SO相关
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 487, 1),
                    url: "SO/lesscompute",
                  },
                  {
                    //SO相关
                    path: "/soprint",
                    name: "2_soprint",
                    label: this.$t("getapi[4945]"), //SO相关
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 146, 1),
                    url: "SO/soprint",
                  },
                  {
                    path: "/facheck",
                    name: "2_facheck",
                    label: this.$t("getapi[6585]"), //FA检验一览
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 247, 1),
                    url: "SO/facheck",
                  },
                  {
                    path: "/urgentso",
                    name: "2_urgentso",
                    label: this.$t("getapi[6417]"), //新增销售订单需紧急下单
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 314, 1),
                    url: "SO/urgentso",
                  },
                    {
                        path: "/orderlisttoexcel",
                        name: "2_orderlisttoexcel",
                        label: this.$t("getapi[8221]"), //原Excel订单自动生成模板
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "SO/orderlisttoexcel",
                    },
                    {
                        //板材待排版一览
                        path: "/enableboard",
                        name: "2_enableboard",
                        label: this.$t("getapi[12903]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 295, 1),
                        url: "issueandgrn/produceissue/enableboard",
                    },
                ],
              },
            ],
          },
          {
            label: this.$t("getapi[6588]"), //发料与入库
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[4005]"), //生产发料相关
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "182|183|287|295", 1),
                children: [
                  {
                    //单SO发料一览
                    path: "/singlesoview",
                    name: "2_singlesoview",
                    label: this.$t("getapi[4006]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 182, 1),
                    url: "issueandgrn/produceissue/singlesoview",
                  },
                  {
                    //单SO发料概览
                    path: "/singlesodetail",
                    name: "2_singlesodetail",
                    label: this.$t("getapi[4007]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 183, 1),
                    url: "issueandgrn/produceissue/singlesodetail",
                  },
                  {
                    //SO集成发料一览
                    path: "/collsoissueview",
                    name: "2_collsoissueview",
                    label: this.$t("getapi[4009]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 287, 1),
                    url: "issueandgrn/produceissue/collsoissueview",
                  },
                  {
                    //SO发料汇总
                    path: "/soissuematerialsdatalist",
                    name: "2_soissuematerialsdatalist",
                    label: this.$t("getapi[4011]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "issueandgrn/produceissue/soissuematerialsdatalist",
                  },
                  {
                    //板材专用发料一览
                    path: "/boardissueview",
                    name: "2_boardissueview",
                    label: this.$t("getapi[4012]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 499, 1),
                    url: "issueandgrn/produceissue/boardissueview",
                  },
                  {
                    //板材排版一览
                    path: "/sorelationview",
                    name: "2_sorelationview",
                    label: this.$t("getapi[4014]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 295, 1),
                    url: "issueandgrn/produceissue/sorelationview",
                  },
                  {
                    //板材排版概览
                    path: "/sorelationdetail",
                    name: "2_sorelationdetail",
                    label: this.$t("getapi[4015]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 295, 1),
                    url: "issueandgrn/produceissue/sorelationdetail",
                  },
                ],
              },
              {
                label: this.$t("getapi[4017]"), //生产入库相关
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "186", 1),
                children: [
                  {
                    //生产入库一览
                    path: "/invreceievein",
                    name: "2_invreceievein",
                    label: this.$t("getapi[4018]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 186, 1),
                    url: "issueandgrn/invreceieve/invreceievein",
                  }, {
                    //生产入库概览
                    path: "/invinlist",
                    name: "2_invinlist",
                    label: this.$t("getapi[4019]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 187, 1),
                    url: "issueandgrn/invreceieve/invinlist",
                  },
                  {
                    //生产入库序列号追溯
                    path: "/selectdc",
                    name: "2_selectdc",
                    label: this.$t("getapi[6347]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 252, 1),
                    url: "issueandgrn/invreceieve/selectdc",
                  },
                  {
                    //DC信息
                    path: "/prodc",
                    name: "2_prodc",
                    label: this.$t("getapi[6376]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 275, 1),
                    url: "issueandgrn/invreceieve/prodc",
                  },
                ],
              },
              {
                label: this.$t("getapi[4021]"), //返修管理
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "209|272", 1),
                children: [
                  {
                    //返修单一览
                    path: "/repairview",
                    name: "2_repairview",
                    label: this.$t("getapi[4022]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 209, 1),
                    url: "issueandgrn/repair/repairview",
                  },
                ],
              },
            ],
          },
          {
            label: this.$t("getapi[6589]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[4024]"), //SO汇报管理
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "208|192|289|291", 1),
                children: [
                  {
                    path: "/reporthistoryview",
                    name: "2_reporthistoryview",
                    label: this.$t("getapi[4025]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 208, 1),
                    url: "Report/soreport/reporthistoryview",
                  },
                  {
                    path: "/soroutingview",
                    name: "2_soroutingview",
                    label: this.$t("getapi[6590]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 192, 1),
                    url: "Report/soreport/soroutingview",
                  },
                  {
                    path: "/workhourimport",
                    name: "2_workhourimport",
                    label: this.$t("getapi[6591]"),//生产汇报工时导入
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 289, 1),
                    url: "Report/workhourimport",
                  },
                  {
                    path: "/alreadyreportnoin",
                    name: "2_alreadyreportnoin",
                    label: this.$t("getapi[4027]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 291, 1),
                    url: "Report/soreport/alreadyreportnoin",
                  },
                  {
                      path: "/reportsequence",
                      name: "2_reportsequence",
                      label: this.$t("getapi[12865]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "Report/soreport/reportsequence",
                  },
                ],
              },
              /*{
                label: "标签", //SR相关
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/invoicelabel",
                        name: "2_invoicelabel",
                        label: "发货单标签",
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "Report/label/invoicelabel",
                    },
                ],
              },*/
              {
                label: this.$t("getapi[4028]"), //流转相关
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "297|", 1),
                children: [
                  {
                    path: "/moveoverdetail",
                    name: "2_moveoverdetail",
                    label: this.$t("getapi[4030]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 297, 1),
                    url: "Report/move/moveoverdetail",
                  },
                ],
              },
              {
                label: this.$t("getapi[6592]"), //SR相关
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  {
                    path: "/workhour",
                    name: "2_workhour",
                    label: this.$t("getapi[6593]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 494, 1),
                    url: "Report/workhour",
                  },
                ],
              },
            ],
          },
          //综合统计
          {
            label: this.$t("getapi[20]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[4032]"),
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  {
                    path: "/cjhw",
                    name: "2_cjhw",
                    label: this.$t("getapi[4033]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 203, 1),
                    url: "MDIP/cjhw",
                  },
                  {
                    path: "/cjbcp",
                    name: "2_cjbcp",
                    label: this.$t("getapi[4034]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 203, 1),
                    url: "MDIP/cjbcp",
                  },
                  {
                    path: "/cjbcpmx",
                    name: "2_cjbcpmx",
                    label: this.$t("getapi[4035]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 203, 1),
                    url: "MDIP/cjbcpmx",
                  },
                  {
                    path: "/bcpqs",
                    name: "2_bcpqs",
                    label: this.$t("getapi[4036]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 203, 1),
                    url: "MDIP/bcpqs",
                  },
                  {
                    path: "/gjgxjy",
                    name: "2_gjgxjy",
                    label: this.$t("getapi[6297]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 203, 1),
                    url: "MDIP/gjgxjy",
                  },
                  {
                    path: "/cjsw",
                    name: "2_cjsw",
                    label: this.$t("getapi[4037]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 204, 1),
                    url: "MDIP/cjsw",
                  },
                    //物料流转记录
                  {
                    path: "/wllz",
                    name: "2_wllz",
                    label: this.$t("getapi[6307]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "MDIP/wllz",
                  },
                ],
              },
              {
                label: this.$t("getapi[4038]"), //SR相关
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  {
                    path: "/sofinish",
                    name: "2_sofinish",
                    label: this.$t("getapi[4039]"),//SO及时完工率
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 497, 1),
                    url: "MDPIP/sofinish",
                  },
                    {
                        path: "/sojishi",
                        name: "2_sojishi",
                        label: this.$t("getapi[4040]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 497, 1),
                        url: "MDPIP/sojishi",
                    },
                    {
                        path: "/sofinishkz",
                        name: "2_sofinishkz",
                        label: this.$t("getapi[8252]"),//SO及时完工率
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 497, 1),
                        url: "MDPIP/sofinishkz",
                    },
                    {
                        path: "/sojishikz",
                        name: "2_sojishikz",
                        label: this.$t("getapi[8253]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 497, 1),
                        url: "MDPIP/sojishikz",
                    },
                    {
                        path: "/sopartcost",
                        name: "2_sopartcost",
                        label: this.$t("getapi[12459]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 497, 1),
                        url: "MDPIP/sopartcost",
                    },
                    {
                        path: "/proissprior",
                        name: "2_proissprior",
                        label: this.$t("getapi[12571]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 461, 1),
                        url: "MDPIP/proissprior",
                    },
                    {
                        path: "/socheckrecord",
                        name: "2_socheckrecord",
                        label: this.$t("getapi[12657]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 462, 1),
                        url: "MDPIP/socheckrecord",
                    },
                    {
                        path: "/puryeardeliveryrate",
                        name: "2_puryeardeliveryrate",
                        label: this.$t("getapi[12836]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: userdate.Login_DB == 'WGZC',
                        url: "MDPIP/puryeardeliveryrate",
                    },
                ],
              },

            ],
          },
          //排产结果
          {
            label: this.$t("getapi[8049]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
           /*   {
                path: "/aps",
                name: "2_aps",
                label: "APS",
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 498, 1),
                url: "MDPIP/aps",
              },*/
                {
                    path: "/apsnew",
                    name: "2_apsnew",
                    label: this.$t("getapi[13285]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 498, 1),
                    url: "MDPIP/apsnew",
                },
              {
                path: "/overduelist",
                name: "2_overduelist",
                label: this.$t("getapi[6594]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 498, 1),
                url: "aps/overduelist",
              },
              {
                  label: this.$t("getapi[6326]"),
                  icon: "caret-right",
                  chb: true,
                  visible: true,
                  children: [
                      {
                          path: "/resource",
                          name: "2_resource",
                          label: this.$t("getapi[6327]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: true,
                          url: "MDPIP/schpro/resource",
                      },
                      {
                          path: "/apsgroup",
                          name: "2_apsgroup",
                          label: this.$t("getapi[12444]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: true,
                          url: "MDPIP/schpro/apsgroup",
                      },
                      {
                          path: "/priority",
                          name: "2_priority",
                          label: this.$t("getapi[6334]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: true,
                          url: "MDPIP/schpro/priority",
                      },
                      {
                          path: "/workcenter",
                          name: "2_workcenter",
                          label: this.$t("getapi[6335]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: true,
                          url: "MDPIP/schpro/workcenter",
                      },
                      {
                          path: "/schprostatus",
                          name: "2_schprostatus",
                          label: this.$t("getapi[6343]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: true,
                          url: "MDPIP/schpro/schprostatus",
                      },
                      {
                          path: "/apsresult",
                          name: "2_apsresult",
                          label: this.$t("getapi[6336]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: true,
                          url: "MDPIP/schpro/apsresult",
                      },
                      {
                          path: "/schduling",
                          name: "2_schduling",
                          label: this.$t("getapi[6586]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: this.$limits.menuvisible("plv2", 276, 1),
                          url: "SO/schduling",
                      },
                      {
                          path: "/schdulingline",
                          name: "2_schdulingline",
                          label: this.$t("getapi[6587]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: this.$limits.menuvisible("plv2", 276, 1),
                          url: "SO/schdulingline",
                      },
                  ],
              },
            ],
          },
          // MRP计算
          {
            label: 'MRP',
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                label: this.$t("getapi[6595]"), //工具
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  {
                    path: "/mrpcount",
                    name: "2_mrpcount",
                    label: this.$t("getapi[6595]"),//MRP计算
                    icon: "arrow-right",
                    chb: false,
                    visible: (this.$limits.authority('plv2', 159, 1) == 2) || (this.$limits.authority('plv2', 384, 1) == 2),
                    url: "mrp/mrpcount/mrpcount",
                  },
                   /* {
                        path: "/penangonhand",
                        name: "2_penangonhand",
                        label: this.$t("getapi[12837]"),//库存预测
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 491, 1),
                        url: "mrp/mrpcount/penangonhand",
                    },*/
                ],
              },
              {
                label: this.$t("getapi[6596]"), //工具
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                  {
                    path: "/mrptranspurorder",
                    name: "2_mrptranspurorder",
                    label: this.$t("getapi[6597]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 503, 1),
                    url: "mrp/tool/mrptranspurorder",
                  },
                  {
                    path: "/mrptranssrorder",
                    name: "2_mrptranssrorder",
                    label: this.$t("getapi[12439]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 576, 1),
                    url: "mrp/tool/mrptranssrorder",
                  },
                  {
                    path: "/automctoprtopur",
                    name: "2_automctoprtopur",
                    label: this.$t("getapi[13536]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "mrp/tool/automctoprtopur",
                  },
                ],
              },
              {
                label: this.$t("getapi[6598]"), //工具
                icon: "caret-right",
                chb: true,
                visible: this.$limits.menuvisible("plv2", 386, 1),
                children: [
                  {
                    path: "/resultview",
                    name: "2_resultview",
                    label: this.$t("getapi[6599]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 386, 1),
                    url: "mrp/countview/resultview",
                  },
                  {
                    path: "/suggestview",
                    name: "2_suggestview",
                    label: this.$t("getapi[6600]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 386, 1),
                    url: "mrp/countview/suggestview",
                  },
                  {
                    path: "/supplydemandinfo",
                    name: "2_supplydemandinfo",
                    label: this.$t("getapi[6601]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 386, 1),
                    url: "mrp/countview/supplydemandinfo",
                  },
                    {
                        path: "/supplydemandremain",
                        name: "2_supplydemandremain",
                        label: this.$t("getapi[13394]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 386, 1),
                        url: "mrp/countview/supplydemandremain",
                    },
                  {
                    path: "/mainsupply",
                    name: "2_mainsupply",
                    label: this.$t("getapi[6602]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 386, 1),
                    url: "mrp/countview/mainsupply",
                  },
                    {
                        path: "/mainsupplyremain",
                        name: "2_mainsupplyremain",
                        label: this.$t("getapi[13281]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 386, 1),
                        url: "mrp/countview/mainsupplyremain",
                    },
                  {
                    path: "/mainsuggestview",
                    name: "2_mainsuggestview",
                    label: this.$t("getapi[6603]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 386, 1),
                    url: "mrp/countview/mainsuggestview",
                  },
                  {
                    path: "/moqlist",
                    name: "2_moqlist",
                    label: this.$t("getapi[6604]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 386, 1),
                    url: "mrp/countview/moqlist",
                  },
                ],
              },
            ],
          },
            //库存分析
          {
                label: this.$t("getapi[12837]"),
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/penangonhand",
                        name: "2_penangonhand",
                        label: this.$t("getapi[12838]"),//主计划外库存分析
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 491, 1),
                        url: "mrp/mrpcount/penangonhand",
                    },
                    {
                        path: "/getonthesea",
                        name: "2_getonthesea",
                        label: this.$t("getapi[12850]"),//在途清单数
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 491, 1),
                        url: "mrp/mrpcount/getonthesea",
                    },
                    {
                        path: "/getontheseanew",
                        name: "2_getontheseanew",
                        label: this.$t("getapi[12850]")+'2',//在途清单数
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 491, 1),
                        url: "mrp/mrpcount/getontheseanew",
                    },
                ],
            },
        ];
        this.menu3 = [
          {
            label: this.$t('getapi[7975]'),
            icon: "s-home",
            chb: false,
            visible: true,
          },
          {
            label: this.$t("getapi[3977]"),
            icon: "s-home",
            chb: false,
            visible: true,
          },
          {
            //采购发票
            label: this.$t("getapi[3836]"),
            icon: "video-play",
            chb: true,
            visible: true,// this.$limits.SecondMenuVisible("plv2","220|230|305",1),
            children: [
                /*{
                    label: this.$t("getapi[13359]"),
                    icon: "caret-right",
                    chb: true,
                    visible: true,
                    children: [
                        {
                            //控制科目
                            path: "/purcontrolsubject",
                            name: "3_purcontrolsubject",
                            label: this.$t("getapi[13391]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 220, 1),
                            url: "purinvoice/purcontrolsubject",
                        },
                        {
                            //对方科目
                            path: "/purothersubject",
                            name: "3_purothersubject",
                            label: this.$t("getapi[13392]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 220, 1),
                            url: "purinvoice/purothersubject",
                        },
                    ]
                },
                {
                    //摘要设置
                    path: "/purinvoiceabstract",
                    name: "3_purinvoiceabstract",
                    label: this.$t("getapi[13360]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 220, 1),
                    url: "purinvoice/purinvoiceabstract",
                },
                {
                    //凭证生成
                    path: "/purcreatevouch",
                    name: "3_purcreatevouch",
                    label: this.$t("getapi[13373]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 220, 1),
                    url: "purinvoice/purcreatevouch",
                },
                {
                    //结算科目
                    path: "/pursettlementsubject",
                    name: "3_pursettlementsubject",
                    label: this.$t("getapi[13377]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 220, 1),
                    url: "purinvoice/pursettlementsubject",
                },*/
              {
                //采购发票一览
                path: "/purinvoiceview",
                name: "3_purinvoiceview",
                label: this.$t("getapi[3676]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 220, 1),
                url: "purinvoice/purinvoiceview",
              },
              {
                //采购发票概览
                path: "/purinvoicedetailview",
                name: "3_purinvoicedetailview",
                label: this.$t("getapi[3707]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 220, 1),
                url: "purinvoice/purinvoicedetailview",
              },
              {
                //采购费用发票概览
                path: "/purinvoicecost",
                name: "3_purinvoicecost",
                label: this.$t("getapi[3839]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 305, 1),
                url: "purinvoice/purinvoicecost",
              },
              {
                //外协发票一览
                path: "/issinvoiceview",
                name: "3_issinvoiceview",
                label: this.$t("getapi[6605]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 230, 1),
                url: "purinvoice/issinvoiceview",
              },
              {
                //外协发票概览
                path: "/issinvoicedetailview",
                name: "3_issinvoicedetailview",
                label: this.$t("getapi[6606]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 230, 1),
                url: "purinvoice/issinvoicedetailview",
              },
              {
                  //外协发票导入
                  path: "/issinvoiceimp",
                  name: "3_issinvoiceimp",
                  label: this.$t("getapi[5087]") + this.$t("getapi[4410]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 230, 1),
                  url: "purinvoice/issinvoiceimp",
              },
              {
                //补差单一览
                path: "/difflist",
                name: "3_difflist",
                label: this.$t("getapi[3665]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 267, 1),
                url: "purinvoice/difflist",
              },
              {
                //应付发票一览
                path: "/finpaymentdue",
                name: "3_finpaymentdue",
                label: this.$t("getapi[6607]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 220, 1) && this.$limits.menuvisible("plv2", 230, 1),
                url: "purinvoice/finpaymentdue",
              },
              {
                //到期款概览
                path: "/fpddue",
                name: "3_fpddue",
                label: this.$t("getapi[6608]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 220, 1) && this.$limits.menuvisible("plv2", 230, 1),
                url: "purinvoice/fpddue",
              },
              {
                //质量扣款一览
                path: "/fpdpenalty",
                name: "3_fpdpenalty",
                label: this.$t("getapi[6609]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 220, 1) && this.$limits.menuvisible("plv2", 230, 1),
                url: "purinvoice/fpdpenalty",
              },
            ],
          },
          {
            //销售发票
            label: this.$t("getapi[3846]"),
            icon: "video-play",
            chb: true,
            visible: true,// this.$limits.SecondMenuVisible("plv2","243|",1),
            children: [
                /*{
                    label: this.$t("getapi[13359]"),
                    icon: "caret-right",
                    chb: true,
                    visible: true,
                    children: [
                        {
                            //控制科目
                            path: "/salecontrolsubject",
                            name: "3_salecontrolsubject",
                            label: this.$t("getapi[13391]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 243, 1),
                            url: "saleinvoice/salecontrolsubject",
                        },
                        {
                            //对方科目
                            path: "/saleothersubject",
                            name: "3_saleothersubject",
                            label: this.$t("getapi[13392]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 243, 1),
                            url: "saleinvoice/saleothersubject",
                        },
                    ]
                },
              {
                  //摘要设置
                  path: "/saleinvoiceabstract",
                  name: "3_saleinvoiceabstract",
                  label: this.$t("getapi[13360]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 243, 1),
                  url: "saleinvoice/saleinvoiceabstract",
              },
              {
                  //凭证生成
                  path: "/createvouch",
                  name: "3_createvouch",
                  label: this.$t("getapi[13373]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 243, 1),
                  url: "saleinvoice/createvouch",
              },
              {
                  //结算科目
                  path: "/settlementsubject",
                  name: "3_settlementsubject",
                  label: this.$t("getapi[13377]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 243, 1),
                  url: "saleinvoice/settlementsubject",
              },*/
              {
                //销售发票一览
                path: "/saleinvoiceview",
                name: "3_saleinvoiceview",
                label: this.$t("getapi[3859]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 243, 1),
                url: "saleinvoice/saleinvoiceview",
              },
              {
                //销售发票概览
                path: "/saleinvoicedetailview",
                name: "3_saleinvoicedetailview",
                label: this.$t("getapi[3866]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 243, 1),
                url: "saleinvoice/saleinvoicedetailview",
              },
              {
                  //销售发票导入
                  path: "/saleinvoiceimp",
                  name: "3_saleinvoiceimp",
                  label: this.$t("getapi[3846]") + this.$t("getapi[4410]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 243, 1),
                  url: "saleinvoice/saleinvoiceimp",
              },
              {
                //销售发票概览
                path: "/salothercostview",
                name: "3_salothercostview",
                label: this.$t("getapi[3858]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 243, 1),
                url: "saleinvoice/salothercostview",
              },
              {
                //销售形式发票一览
                path: "/invoiceviewprint",
                name: "3_invoiceviewprint",
                label: this.$t("getapi[6610]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 243, 1),
                url: "saleinvoice/invoiceviewprint",
              },
                {
                    //收款明细一览
                    path: "/finreceivables",
                    name: "3_finreceivables",
                    label: this.$t("getapi[8213]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 557, 1),
                    url: "purinvoice/finreceivables",
                },
     /*           {
                    //收款明细导入
                    path: "/finreceivablesimp",
                    name: "3_finreceivablesimp",
                    label: this.$t("getapi[8214]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "purinvoice/finreceivablesimp",
                },*/
                {
                    //应收账款月统计表
                    path: "/finrectab",
                    name: "3_finrectab",
                    label: this.$t("getapi[8218]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 558, 1),
                    url: "saleinvoice/finrectab",
                },
                {
                    //应收账款明细表
                    path: "/finrecinfotab",
                    name: "3_finrecinfotab",
                    label: this.$t("getapi[8219]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 559, 1),
                    url: "saleinvoice/finrecinfotab",
                },
                {
                    //应收账款回款统计表
                    path: "/finrecdaytab",
                    name: "3_finrecdaytab",
                    label: this.$t("getapi[12478]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "saleinvoice/finrecdaytab",
                },
                {
                    //计提质量扣款
                    path: "/salmonthcount",
                    name: "3_salmonthcount",
                    label: this.$t("getapi[12306]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "purinvoice/salmonthcount",
                },
                {
                    //销售月统计表
                    path: "/salmonthcounttable",
                    name: "3_salmonthcounttable",
                    label: this.$t("getapi[12307]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 243, 1),
                    url: "purinvoice/salmonthcounttable",
                },
                // 销售管理-销售账务-销售月统计分表
                {
                    path: "/monchartinfo",
                    name: "monchartinfo",
                    label: this.$t("getapi[13436]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 122, 1),
                    url: "menu1/sales/accounting/monchartinfo",
                },
                {
                    //销售差异分析表
                    path: "/salmonthcountdif",
                    name: "3_salmonthcountdif",
                    label: this.$t("getapi[12308]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 243, 1),
                    url: "purinvoice/salmonthcountdif",
                },
                // 销售管理-销售账务-销售大表
                {
                    path: "/salinvoiceshipnotedetail",
                    name: "3_salinvoiceshipnotedetail",
                    label: this.$t("getapi[13058]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "saleinvoice/salinvoiceshipnotedetail",
                  },
                  // 销售管理-销售账务-销售大表导入
                  {
                    path: "/salinvoiceshipnoteimport",
                    name: "3_salinvoiceshipnoteimport",
                    label: this.$t("getapi[13071]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "saleinvoice/salinvoiceshipnoteimport",
                  },
                //销售折扣
                {
                    label: this.$t("getapi[12414]"),
                    icon: "caret-right",
                    chb: true,
                    visible: true,
                    children: [
                        //销售折扣计提
                        {
                            path: "/saldiscountbaseinfo",
                            name: "3_saldiscountbaseinfo",
                            label: this.$t("getapi[12415]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "saleaccount/saldiscountbaseinfo",
                        },
                        {
                            path: "/saldiscountoldpart",
                            name: "3_saldiscountoldpart",
                            label: this.$t("getapi[12416]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "saleaccount/saldiscountoldpart",
                        },
                        {
                            path: "/saldiscountdif",
                            name: "3_saldiscountdif",
                            label: this.$t("getapi[12417]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "saleaccount/saldiscountdif",
                        },
                        {
                            path: "/saldiscountdiftrim",
                            name: "3_saldiscountdiftrim",
                            label: this.$t("getapi[12418]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "saleaccount/saldiscountdiftrim",
                        },
                        {
                            path: "/saldiscountrec",
                            name: "3_saldiscountrec",
                            label: this.$t("getapi[12419]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "saleaccount/saldiscountrec",
                        },
                        {
                            path: "/saldiscounttable",
                            name: "3_saldiscounttable",
                            label: this.$t("getapi[12420]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "saleaccount/saldiscounttable",
                        },
                    ]
                },
            ],
          },
          {
            //付款统计
            label: this.$t("getapi[5131]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
                {
                    //预付单一览
                    path: "/prepaymentoverview",
                    name: "3_prepaymentoverview",
                    label: this.$t("getapi[5074]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 236, 1),
                    url: "frmpay/prepaymentoverview",
                },
                {
                    //付款单一览
                    path: "/paymentoverview",
                    name: "3_paymentoverview",
                    label: this.$t("getapi[5077]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 238, 1),
                    url: "frmpay/paymentoverview",
                },
                {
                    //付款单概览
                    path: "/paymentdetail",
                    name: "3_paymentdetail",
                    label: this.$t("getapi[5084]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 235, 1),
                    url: "frmpay/paymentdetail",
                },
                {
                    //批量导入付款单
                    path: "/paymentimport",
                    name: "3_paymentimport",
                    label: this.$t("getapi[9296]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 238, 1),
                    url: "frmpay/paymentimport",
                },
                {
                    //到期债务列表
                    path: "/paymentschedule",
                    name: "3_paymentschedule",
                    label: this.$t("getapi[9065]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 241, 1),
                    url: "frmpay/paymentschedule",
                },
                {
                    //期初余额
                    path: "/popeningbalance",
                    name: "3_popeningbalance",
                    label: this.$t("getapi[13627]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "frmpay/popeningbalance",
                },
                {
                    //应付单一览
                    path: "/payableoverview",
                    name: "3_payableoverview",
                    label: this.$t("getapi[13544]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "frmpay/payableoverview",
                },
                {
                    //核销
                    path: "/pwriteoff",
                    name: "3_pwriteoff",
                    label: this.$t("getapi[13632]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "frmpay/pwriteoff",
                },
                {
                    //应付款汇总表
                    path: "/finpaymentsum",
                    name: "3_finpaymentsum",
                    label: this.$t("getapi[9066]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 242, 1),
                    url: "frmpay/finpaymentsum",
                },
                {
                    //预付核销单一览
                    path: "/prepaymentverifyview",
                    name: "3_prepaymentverifyview",
                    label: this.$t("getapi[9215]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 239, 1),
                    url: "frmpay/prepaymentverifyview",
                },
                {
                    //应付账款账龄表
                    path: "/paymentcollectview",
                    name: "3_paymentcollectview",
                    label: this.$t("getapi[9357]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 286, 1),
                    url: "frmpay/paymentcollectview",
                },
              {
                //支付单据一览
                path: "/fpdpay",
                name: "3_fpdpay",
                label: this.$t("getapi[6611]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 241, 1),
                url: "frmpay/fpdpay",
              },
              {
                //金蝶账期一览（供应商）
                path: "/fpdvender",
                name: "3_fpdvender",
                label: this.$t("getapi[6612]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 241, 1),
                url: "frmpay/fpdvender",
              },
              {
                //金蝶账期一览（K3数据）
                path: "/fpdk3",
                name: "3_fpdk3",
                label: this.$t("getapi[6613]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 241, 1),
                url: "frmpay/fpdk3",
              },
            ],
          },
          {
              //收款统计
              label: this.$t("getapi[5132]"),
              icon: "video-play",
              chb: true,
              visible: true,
              children: [
                  {
                      //预收单一览
                      path: "/prementoverview",
                      name: "3_prementoverview",
                      label: this.$t("getapi[5105]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: this.$limits.menuvisible("plv2", 254, 1),
                      url: "receivement/prementoverview",
                  },
                  {
                      //收款单一览
                      path: "/receivementview",
                      name: "3_receivementview",
                      label: this.$t("getapi[5114]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: this.$limits.menuvisible("plv2", 255, 1),
                      url: "receivement/receivementview",
                  },
                  {
                      //收款单概览
                      path: "/receivementdetail",
                      name: "3_receivementdetail",
                      label: this.$t("getapi[5121]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: this.$limits.menuvisible("plv2", 256, 1),
                      url: "receivement/receivementdetail",
                  },
                  {
                      //期初余额
                      path: "/ropeningbalance",
                      name: "3_ropeningbalance",
                      label: this.$t("getapi[13627]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "receivement/ropeningbalance",
                  },
                  {
                      //应收单一览
                      path: "/receiveableview",
                      name: "3_receiveableview",
                      label: this.$t("getapi[13549]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "receivement/receiveableview",
                  },
                  {
                      //核销
                      path: "/rwriteoff",
                      name: "3_rwriteoff",
                      label: this.$t("getapi[13632]"),
                      icon: "arrow-right",
                      chb: false,
                      visible: true,
                      url: "receivement/rwriteoff",
                  },
              ],
          },
          {
            //定制功能
            label: this.$t("getapi[6614]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                path: "/financedata",
                name: "3_financedata",
                label: this.$t("getapi[6344]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 242, 1),
                url: "customfunction/financedata",
              },
              {
                //同步发票图片
                path: "/synchroinvoice",
                name: "3_synchroinvoice",
                label: this.$t("getapi[6615]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 221, 1) || this.$limits.menuvisible("plv2", 231, 1) || this.$limits.menuvisible("plv2", 244, 1),
                url: "customfunction/synchroinvoice",
              },
              {
                  //发票批量上传
                  path: "/batchuploadinvoice",
                  name: "3_batchuploadinvoice",
                  label: this.$t("getapi[12577]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 221, 1) || this.$limits.menuvisible("plv2", 231, 1) || this.$limits.menuvisible("plv2", 244, 1),
                  url: "customfunction/batchuploadinvoice",
              },
              {
                  //用开票系统发票号更新销售发票号
                  path: "/outchangeinvoiceno",
                  name: "3_outchangeinvoiceno",
                  label: this.$t("getapi[13016]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: true,
                  url: "customfunction/outchangeinvoiceno",
              },
              {
                  //开票系统中间表
                  path: "/sysoutdata",
                  name: "3_sysoutdata",
                  label: this.$t("getapi[13018]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 594, 1),
                  url: "customfunction/sysoutdata",
              },
            ]
          },
          {
            //财务 采购管理
            label: this.$t("getapi[8043]"),
            icon: "video-play",
            chb: true,
            visible: true,//this.$limits.SecondMenuVisible("plv2","243|",1),
            children: [
              {
                //最近采购单价
                path: "/latestpurprice",
                name: "3_latestpurprice",
                label: this.$t("getapi[6616]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 402, 1),
                url: "puraccount/latestpurprice",
              },
              {
                //截止年度最近采购价
                path: "/latestyearpurprice",
                name: "3_latestyearpurprice",
                label: this.$t("getapi[6617]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 403, 1),
                url: "puraccount/latestyearpurprice",
              },
              {
                //采购有效价表均价
                path: "/purprice",
                name: "3_purprice",
                label: this.$t("getapi[6618]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 404, 1),
                url: "puraccount/purprice",
              },
              {
                //采购暂估明细
                path: "/purestimate",
                name: "3_purestimate",
                label: this.$t("getapi[6619]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 460, 1),
                url: "estimate/purestimate",
              }
            ]
          },
          {
            //外协管理
            label: this.$t("getapi[8044]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                path: "/halfwxview",
                name: "3_halfwxview",
                label: this.$t("getapi[6620]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 405, 1),
                url: "wx/halfwxview",
              },
              {
                path: "/wxtotal",
                name: "3_wxtotal",
                label: this.$t("getapi[6621]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 406, 1),
                url: "wx/wxtotal",
              },
              {
                path: "/wxdetail",
                name: "3_wxdetail",
                label: this.$t("getapi[6622]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 407, 1),
                url: "wx/wxdetail",
              },
              {
                path: "/wxzg",
                name: "3_wxzg",
                label: this.$t("getapi[6623]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 408, 1),
                url: "wx/wxzg",
              },
            ]
          },
          {
            //销售管理
            label: this.$t("getapi[8045]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                path: "/saledetail",
                name: "3_saledetail",
                label: this.$t("getapi[6624]"),
                icon: "caret-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 409, 1),
                url: "saleaccount/saledetail",
              },
              {
                label: this.$t("getapi[6625]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "410|411|412|413", 1),
                children: [
                  {
                    path: "/acus",
                    name: "3_acus",
                    label: this.$t("getapi[6626]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 410, 1),
                    url: "saleaccount/acus",
                  },
                  {
                    path: "/acusitem",
                    name: "3_acusitem",
                    label: this.$t("getapi[6627]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 411, 1),
                    url: "saleaccount/acusitem",
                  },
                  {
                    path: "/acusmaster",
                    name: "3_acusmaster",
                    label: this.$t("getapi[6628]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 412, 1),
                    url: "saleaccount/acusmaster",
                  },
                ]
              },
              {
                path: "/cussalerate",
                name: "3_cussalerate",
                label: this.$t("getapi[6629]"),
                icon: "caret-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 413, 1),
                url: "saleaccount/cussalerate",
              },
              {
                path: "/salezgdetail",
                name: "3_salezgdetail",
                label: this.$t("getapi[6630]"),
                icon: "caret-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 414, 1),
                url: "saleaccount/salezgdetail",
              },
              {
                path: "/arecieve",
                name: "3_arecieve",
                label: this.$t("getapi[6631]"),
                icon: "caret-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 415, 1),
                url: "saleaccount/arecieve",
              },
              {
                path: "/arecievec",
                name: "3_arecievec",
                label: this.$t("getapi[6632]"),
                icon: "caret-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 416, 1),
                url: "saleaccount/arecievec",
              },
                {
                    path: "/salgpm",
                    name: "3_salgpm",
                    label: this.$t("getapi[9818]"),
                    icon: "caret-right",
                    chb: false,
                    visible: true,
                    url: "saleaccount/3_salgpm",
                },
                {
                    path: "/finscrapcostshareview",
                    name: "3_finscrapcostshareview",
                    label: this.$t("getapi[8938]"),
                    icon: "caret-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 398, 1),
                    url: "saleaccount/finscrapcostshareview",
                },
              {
                  path: "/finscrapcostshare",
                  name: "3_finscrapcostshare",
                  label: this.$t("getapi[6592]"),
                  icon: "caret-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 398, 1),
                  url: "saleaccount/finscrapcostshare",
              },
              {
                  path: "/finscrapcostshareimp",
                  name: "3_finscrapcostshareimp",
                  label: this.$t("getapi[8249]"),
                  icon: "caret-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2", 398, 1),
                  url: "saleaccount/finscrapcostshareimp",
              },
            ]
          },

          {
            //成本核算管理
            label: this.$t("getapi[6633]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
                /*{
                    label: this.$t("getapi[13359]"),
                    icon: "caret-right",
                    chb: true,
                    visible: true,
                    children: [
                        {
                            //存货科目
                            path: "/costinventorysubject",
                            name: "3_costinventorysubject",
                            label: this.$t("getapi[13395]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "glcost/costinventorysubject",
                        },
                        {
                            //对方科目
                            path: "/costothersubject",
                            name: "3_costothersubject",
                            label: this.$t("getapi[13392]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "glcost/costothersubject",
                        },
                    ]
                },
                {
                    label: this.$t("getapi[13406]"),
                    icon: "caret-right",
                    chb: true,
                    visible: true,
                    children: [
                        {
                            //暂估业务录入
                            path: "/estimateinput",
                            name: "3_estimateinput",
                            label: this.$t("getapi[13407]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "glcost/estimateinput",
                        },
                        {
                            //暂估业务处理
                            path: "/estimatehandle",
                            name: "3_estimatehandle",
                            label: this.$t("getapi[13408]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: true,
                            url: "glcost/estimatehandle",
                        },
                    ]
                },
                {
                    //摘要设置
                    path: "/costabstract",
                    name: "3_costabstract",
                    label: this.$t("getapi[13360]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "glcost/costabstract",
                },
                {
                    //凭证生成
                    path: "/costcreatevouch",
                    name: "3_costcreatevouch",
                    label: this.$t("getapi[13373]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: true,
                    url: "glcost/costcreatevouch",
                },*/
              {
                label: this.$t("getapi[6633]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "417", 1),
                children: [
                  {
                    path: "/monthworkview",
                    name: "3_monthworkview",
                    label: this.$t("getapi[6635]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 417, 1),
                    url: "monthwork/monthworkview",
                  },
                  {
                    path: "/monthworkexport",
                    name: "3_monthworkexport",
                    label: this.$t("getapi[6634]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 417, 1),
                    url: "monthwork/monthworkexport",
                  },
                  {
                    path: "/monthmanchargecost",
                    name: "3_monthmanchargecost",
                    label: this.$t("getapi[12501]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 417, 1),
                    url: "monthwork/monthmanchargecost",
                  },
                ]
              },
              {
                label: this.$t("getapi[6636]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "418|419|420|421|422|423", 1),
                children: [
                  {
                    //BOM定额成本一览
                    path: "/bomcost",
                    name: "3_bomcost",
                    label: this.$t("getapi[6637]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 418, 1),
                    url: "costaccountmanage/bomcost",
                  },
                  {
                    //定额工费一览
                    path: "/stdcost",
                    name: "3_stdcost",
                    label: this.$t("getapi[6638]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 419, 1),
                    url: "costaccountmanage/stdcost",
                  },
                  {
                    //标准费率一览
                    path: "/stdrate",
                    name: "3_stdrate",
                    label: this.$t("getapi[6639]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 420, 1),
                    url: "costaccountmanage/stdrate",
                  },
                  {
                    //额定工时一览
                    path: "/summanhour",
                    name: "3_summanhour",
                    label: this.$t("getapi[6640]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 421, 1),
                    url: "costaccountmanage/summanhour",
                  },
                  {
                    //标准卷积外协费用一览
                    path: "/sumoutsource",
                    name: "3_sumoutsource",
                    label: this.$t("getapi[6641]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 422, 1),
                    url: "costaccountmanage/sumoutsource",
                  },
                  {
                    //在制定额成本一览
                    path: "/stdwipcost",
                    name: "3_stdwipcost",
                    label: this.$t("getapi[6642]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 423, 1),
                    url: "costaccountmanage/stdwipcost",
                  },
                ],
              },
              {
                label: this.$t("getapi[6643]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "424|425|426|427|428|429|430|431|432", 1),
                children: [
                  {
                    path: "/costcompute",
                    name: "3_costcompute",
                    label: this.$t("getapi[6643]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 424, 1),
                    url: "actcost/costcompute",
                  },
                  {
                    path: "/monthcostview",
                    name: "3_monthcostview",
                    label: this.$t("getapi[6644]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 425, 1),
                    url: "actcost/monthcostview",
                  },
                  {
                    path: "/costhis",
                    name: "3_costhis",
                    label: this.$t("getapi[6645]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 426, 1),
                    url: "actcost/costhis",
                  },
                  {
                    path: "/quotacostcompute",
                    name: "3_quotacostcompute",
                    label: this.$t("getapi[6646]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 427, 1),
                    url: "actcost/quotacostcompute",
                  },
                  {
                    path: "/conhour",
                    name: "3_conhour",
                    label: this.$t("getapi[6647]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 428, 1),
                    url: "actcost/conhour",
                  },
                  {
                    path: "/conhourmanager",
                    name: "3_conhourmanager",
                    label: this.$t("getapi[6648]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 429, 1),
                    url: "actcost/conhourmanager",
                  },
                  {
                    path: "/scrapcost",
                    name: "3_scrapcost",
                    label: this.$t("getapi[6649]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 430, 1),
                    url: "actcost/scrapcost",
                  },
                  {
                    //BOM定额成本一览
                    path: "/reccost",
                    name: "3_reccost",
                    label: this.$t("getapi[6650]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 431, 1),
                    url: "actcost/reccost",
                  },
                  {
                    //BOM定额成本一览
                    path: "/diffcost",
                    name: "3_diffcost",
                    label: this.$t("getapi[6651]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 432, 1),
                    url: "actcost/diffcost",
                  },

                ],
              },
              {
                label: this.$t("getapi[6652]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "433|434|435", 1),
                children: [
                  // {
                  //   path: "/reccostview",
                  //   name: "3_reccostview",
                  //   label: '入库成本调整单一览',
                  //   icon: "arrow-right",
                  //   chb: false,
                  //   visible: this.$limits.menuvisible("plv2", 433, 1),
                  //   url: "recincostchange/reccostview",
                  // },
                  {
                    path: "/reccostmanage",
                    name: "3_reccostmanage",
                    label: this.$t("getapi[6653]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 433, 1),
                    url: "recincostchange/reccostmanage",
                  },
                  {
                    path: "/reccostdetail",
                    name: "3_reccostdetail",
                    label: this.$t("getapi[6654]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 434, 1),
                    url: "recincostchange/reccostdetail",
                  },
                  {
                    path: "/outcostpanel",
                    name: "3_outcostpanel",
                    label: this.$t("getapi[6655]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 435, 1),
                    url: "recincostchange/outcostpanel",
                  },
                ]
              },
              {
                label: this.$t("getapi[6656]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "436|437|438|439|440|441|442|443|444", 1),
                children: [
                  {
                    path: "/splitmonth",
                    name: "3_splitmonth",
                    label: this.$t("getapi[6657]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 436, 1),
                    url: "stock/splitmonth",
                  },
                  {
                    path: "/monthrecdetail",
                    name: "3_monthrecdetail",
                    label: this.$t("getapi[6658]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 437, 1),
                    url: "stock/monthrecdetail",
                  },
                  {
                    path: "/monthstock",
                    name: "3_monthstock",
                    label: this.$t("getapi[6659]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 438, 1),
                    url: "stock/monthstock",
                  },
                  {
                    path: "/monthstockmore",
                    name: "3_monthstockmore",
                    label: this.$t("getapi[6660]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 439, 1),
                    url: "stock/monthstockmore",
                  },
                  {
                    path: "/mothoutcaculate",
                    name: "3_mothoutcaculate",
                    label: this.$t("getapi[6661]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 440, 1),
                    url: "stock/mothoutcaculate",
                  },
                  {
                    path: "/mothincaculate",
                    name: "3_mothincaculate",
                    label: this.$t("getapi[6662]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 441, 1),
                    url: "stock/mothincaculate",
                  },
                  {
                    path: "/stockdetail",
                    name: "3_stockdetail",
                    label: this.$t("getapi[6663]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 442, 1),
                    url: "stock/stockdetail",
                  },
                  {
                    path: "/monthstockdetail",
                    name: "3_monthstockdetail",
                    label: this.$t("getapi[6664]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 443, 1),
                    url: "stock/monthstockdetail",
                  },
                  {
                    path: "/totaldetail",
                    name: "3_totaldetail",
                    label: this.$t("getapi[6665]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 444, 1),
                    url: "stock/totaldetail",
                  },
                ]
              },
              {
                label: this.$t("getapi[6666]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "445|446|447|448|449|450|451|452|525", 1),
                children: [
                  {
                    //月度在制成本
                    path: "/wipcost",
                    name: "3_wipcost",
                    label: this.$t("getapi[6667]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 445, 1),
                    url: "costacountwip/wipcost",
                  },
                  {
                    //月度死在制成本
                    path: "/deadwipcost",
                    name: "3_deadwipcost",
                    label: this.$t("getapi[6668]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 446, 1),
                    url: "costacountwip/deadwipcost",
                  },
                  {
                    //在制成本汇总
                    path: "/wipsum",
                    name: "3_wipsum",
                    label: this.$t("getapi[6669]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 447, 1),
                    url: "costacountwip/wipsum",
                  },
                  {
                    //期未在制锁定-整单
                    path: "/nobalancelock",
                    name: "3_nobalancelock",
                    label: this.$t("getapi[6670]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 448, 1),
                    url: "costacountwip/nobalancelock",
                  },
                  {
                    //期未在制锁定-整单
                    path: "/nobalancelockrout",
                    name: "3_nobalancelockrout",
                    label: this.$t("getapi[6671]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 449, 1),
                    url: "costacountwip/nobalancelockrout",
                  },
                  {
                    //在制成本汇总-按客户
                    path: "/wipcostcustomer",
                    name: "3_wipcostcustomer",
                    label: this.$t("getapi[6672]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 450, 1),
                    url: "costacountwip/wipcostcustomer",
                  },
                  {
                    //在制成本汇总-按下达日期
                    path: "/wipcostsoapprovetime",
                    name: "3_wipcostsoapprovetime",
                    label: this.$t("getapi[6673]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 451, 1),
                    url: "costacountwip/wipcostsoapprovetime",
                  },
                  {
                    //在制汇总统计
                    path: "/wipsumasday",
                    name: "3_wipsumasday",
                    label: this.$t("getapi[6674]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 452, 1),
                    url: "costacountwip/wipsumasday",
                  },
                    {
                        //成本结转
                        path: "/updatepparth",
                        name: "3_updatepparth",
                        label: this.$t("getapi[6675]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 525, 1),
                        url: "costacountwip/updatepparth",
                    },
                    {
                        //工单检索发原料
                        path: "/materialbyso",
                        name: "3_materialbyso",
                        label: this.$t("getapi[13356]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 603, 1),
                        url: "costacountwip/materialbyso",
                    },
                ],
              },
              {
                label: this.$t("getapi[6676]"),
                icon: "caret-right",
                chb: true,
                visible: this.$limits.SecondMenuVisible("plv2", "453|454|456|457|458", 1),
                children: [
                  {
                    //月度SO发料明细
                    path: "/somaterialissue",
                    name: "3_somaterialissue",
                    label: this.$t("getapi[6677]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 453, 1),
                    url: "costacountwip/somaterialissue",
                  },
                  {
                    //月度SO数量表
                    path: "/monthsoqty",
                    name: "3_monthsoqty",
                    label: this.$t("getapi[6678]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 454, 1),
                    url: "costacountwip/monthsoqty",
                  },
                  {
                    //月关闭SO一览
                    path: "/monthcloseso",
                    name: "3_monthcloseso",
                    label: this.$t("getapi[6679]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 455, 1),
                    url: "costacountwip/monthcloseso",
                  },
                  {
                    //SO信息概览
                    path: "/soinfo",
                    name: "3_soinfo",
                    label: this.$t("getapi[6680]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 456, 1),
                    url: "costacountwip/soinfo",
                  },
                  {
                    //SO汇报历史
                    path: "/proreporthistory",
                    name: "3_proreporthistory",
                    label: this.$t("getapi[6681]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 457, 1),
                    url: "costacountwip/proreporthistory",
                  },
                  {
                    //SO汇报汇总
                    path: "/proreportsum",
                    name: "3_proreportsum",
                    label: this.$t("getapi[6682]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 458, 1),
                    url: "costacountwip/proreportsum",
                  },
                ],
              },
                {
                    label: this.$t("getapi[13155]"),
                    icon: "caret-right",
                    chb: true,
                    visible: this.$limits.SecondMenuVisible("plv2", "599|600|400", 1),
                    children: [
                        {
                            //换号收发存一览
                            path: "/finbalanceinventory",
                            name: "3_finbalanceinventory",
                            label: this.$t("getapi[13157]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 599, 1),
                            url: "materialchange/finbalanceinventory",
                        },
                        {
                            //换号销货明细表
                            path: "/salinvoicechange",
                            name: "3_salinvoicechange",
                            label: this.$t("getapi[13158]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 600, 1),
                            url: "materialchange/salinvoicechange",
                        },
                        {
                            //按客户统计换号销货明细表
                            path: "/salinvoicebycustchange",
                            name: "3_salinvoicebycustchange",
                            label: this.$t("getapi[13264]"),
                            icon: "arrow-right",
                            chb: false,
                            visible: this.$limits.menuvisible("plv2", 400, 1),
                            url: "materialchange/salinvoicebycustchange",
                        },
                    ],
                },
            ]
          },
          {
            //暂估管理
            label: this.$t("getapi[6683]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //暂估数据更新
                path: "/estimateupdate",
                name: "3_estimateupdate",
                label: this.$t("getapi[6684]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 459, 1),
                url: "estimate/estimateupdate",
              },
              /*{
                  //销售暂估明细
                  path: "/salestimate",
                  name: "3_salestimate",
                  label: '销售暂估明细',
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2",462, 1),
                  url: "estimate/salestimate",
              },
              {
                  //采购暂估明细
                  path: "/purestimate",
                  name: "3_purestimate",
                  label: '采购暂估明细',
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2",460, 1),
                  url: "estimate/purestimate",
              },
              {
                  //外协暂估明细
                  path: "/issestimate",
                  name: "3_issestimate",
                  label: '外协暂估明细',
                  icon: "arrow-right",
                  chb: false,
                  visible: this.$limits.menuvisible("plv2",461, 1),
                  url: "estimate/issestimate",
              },*/
            ]
          },
          {
            //研发管理
            label: this.$t("getapi[6685]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //研发领料单项目信息
                path: "/requireitem",
                name: "3_requireitem",
                label: this.$t("getapi[6686]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 463, 1),
                url: "require/requireitem",
              },
              {
                //研发领料单概览
                path: "/requiredetail",
                name: "3_requiredetail",
                label: this.$t("getapi[6687]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 464, 1),
                url: "require/requiredetail",
              },
              {
                //研发领料单一览
                path: "/requireview",
                name: "3_requireview",
                label: this.$t("getapi[6688]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 465, 1),
                url: "require/requireview",
              },
            ]
          },
          {
            //盘点管理
            label: this.$t("getapi[979]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //盘点卡一览
                path: "/countcard",
                name: "3_countcard",
                label: this.$t("getapi[6689]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 466, 1),
                url: "check/countcard",
              },
                // 盘点卡批量导入
                {
                    path: "/countimport",
                    name: "3_countimport",
                    label: this.$t("getapi[8180]"),
                    icon: "arrow-right",
                    chb: false,
                    visible: this.$limits.menuvisible("plv2", 466, 1),
                    url: "check/countimport",
                },
              {
                //盘点监控一览
                path: "/countmonitor",
                name: "3_countmonitor",
                label: this.$t("getapi[6690]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 467, 1),
                url: "check/countmonitor",
              },
              {
                //定额在制成本计算
                path: "/costcalc",
                name: "3_costcalc",
                label: this.$t("getapi[6691]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 509, 1),
                url: "check/costcalc",
              },
              {
                  //盘点差异
                  path: "/partdiff",
                  name: "3_partdiff",
                  label: this.$t("getapi[12886]"),
                  icon: "arrow-right",
                  chb: false,
                  visible: true,
                  url: "check/partdiff",
              },
            ]
          },
          {
            //月结管理
            label: this.$t("getapi[4985]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //会计期间表
                path: "/accountperiod",
                name: "3_accountperiod",
                label: this.$t("getapi[4984]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 468, 1),
                url: "monthbalance/accountperiod",
              },
              {
                //执行月结
                path: "/executemonthbalance",
                name: "3_executemonthbalance",
                label: this.$t("getapi[4991]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 469, 1),
                url: "monthbalance/executemonthbalance",
              },
            ]
          },
          {
            //平衡检测
            label: this.$t("getapi[6692]"),
            icon: "video-play",
            chb: true,
            visible: true,
            children: [
              {
                //会计期间表
                path: "/bdiscitem",
                name: "3_bdiscitem",
                label: this.$t("getapi[6693]"),
                icon: "arrow-right",
                chb: false,
                visible: this.$limits.menuvisible("plv2", 470, 1),
                url: "bdiscitem/bdiscitem",
              },
            ]
          },
            {
                //机加工核算
                label: this.$t("getapi[8538]"),
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                    {
                        //收发存格式
                        path: "/sfc",
                        name: "3_sfc",
                        label: this.$t("getapi[8539]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "finmachining/sfc",
                    },
                    {
                        //销售明细格式
                        path: "/xsmx",
                        name: "3_xsmx",
                        label: this.$t("getapi[8540]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "finmachining/xsmx",
                    },
                    {
                        //在制明细格式
                        path: "/zzmx",
                        name: "3_zzmx",
                        label: this.$t("getapi[8541]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "finmachining/zzmx",
                    },
                ]
            },
            {
                //多库查询
                label: this.$t("getapi[12534]"),
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                    {
                        //销售发票一览
                        path: "/frmsaleinvoice",
                        name: "3_frmsaleinvoice",
                        label: this.$t("getapi[3859]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "multifactory/frmsaleinvoice",
                    },
                    {
                        //销售汇总按客户统计
                        path: "/getsalsumascustomer",
                        name: "3_getsalsumascustomer",
                        label: this.$t("getapi[12535]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "multifactory/getsalsumascustomer",
                    },
                ]
            },
            {
                //同步任务
                label: '同步任务',
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/syntask",
                        name: "syntask",
                        label: '同步任务',
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "syntask/syntask",
                    },
                ],
            },
            /*{
                //凭证
                label: '凭证',
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/vouch",
                        name: "vouch",
                        label: '记账凭证',
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "menu3/vouch/vouch",
                    },
                    {
                        path: "/vouchbrowerfilter",
                        name: "vouchbrowerfilter",
                        label: '凭证审/记/打印',
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "menu3/vouch/vouchbrowerfilter",
                    },
                ],
            },*/
         /*   {
                //同步任务
                label: '同步任务',
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/syntask",
                        name: "syntask",
                        label: '同步任务',
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "syntask/syntask",
                    },
                ],
            },
            {
                //PDCA
                label: 'PDCA',
                icon: "video-play",
                chb: true,
                visible: true,
                children: [
                    {
                        label: 'PDCA报表',
                        icon: "video-play",
                        chb: true,
                        visible: true,
                        children: [
                            {
                                path: "/pdca1",
                                name: "pdca1",
                                label: '收支预测报表',
                                icon: "arrow-right",
                                chb: false,
                                visible: true,
                                url: "pdca/pdca1",
                            },
                            {
                                path: "/pdca2",
                                name: "pdca2",
                                label: '生产费用报表',
                                icon: "arrow-right",
                                chb: false,
                                visible: true,
                                url: "pdca/pdca2",
                            },
                            {
                                path: "/pdca3",
                                name: "pdca3",
                                label: '预算实绩',
                                icon: "arrow-right",
                                chb: false,
                                visible: true,
                                url: "pdca/pdca3",
                            },
                            {
                                path: "/pdca4",
                                name: "pdca4",
                                label: '人工生产产值',
                                icon: "arrow-right",
                                chb: false,
                                visible: true,
                                url: "pdca/pdca4",
                            },
                            {
                                path: "/pdca5",
                                name: "pdca5",
                                label: '部门加班时间表',
                                icon: "arrow-right",
                                chb: false,
                                visible: true,
                                url: "pdca/pdca5",
                            },
                            {
                                path: "/pdca6",
                                name: "pdca6",
                                label: 'MS人件费削减',
                                icon: "arrow-right",
                                chb: false,
                                visible: true,
                                url: "pdca/pdca6",
                            },
                            {
                                path: "/pdca7",
                                name: "pdca7",
                                label: '资金计划与实绩',
                                icon: "arrow-right",
                                chb: false,
                                visible: true,
                                url: "pdca/pdca7",
                            },
                        ],
                    },
                ],
            },*/
        ];
        this.menu4 = [
              {
                  label: this.$t('getapi[7975]'),
                  icon: "s-home",
                  chb: false,
                  visible: true,
              },
              {
                  label: 'KPI',
                  icon: "s-home",
                  chb: false,
                  visible: true,
              },
            {
                label: this.$t("getapi[8024]"), //销售类
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/salstaticsbymonth",
                        name: "4_salstaticsbymonth",
                        label: this.$t("getapi[8025]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 529, 1),
                        url: "sal/salstaticsbymonth",
                    },
                    {
                        path: "/salstaticsbyyear",
                        name: "4_salstaticsbyyear",
                        label: this.$t("getapi[8026]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 530, 1),
                        url: "sal/salstaticsbyyear",
                    },
                    {
                        path: "/finrecmonthrate",
                        name: "4_finrecmonthrate",
                        label: this.$t("getapi[12265]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "sal/finrecmonthrate",
                    },
                    {
                        path: "/cusorderdeliveryrate",
                        name: "4_cusorderdeliveryrate",
                        label: this.$t("getapi[12870]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "sal/cusorderdeliveryrate",
                    },
                ],
            },
            {
                label: this.$t("getapi[8027]"), //过期数据
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/checknohealth",
                        name: "4_checknohealth",
                        label: this.$t("getapi[8028]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 531, 1),
                        url: "expireddate/checknohealth",
                    },
                ],
            },
            {
                label: this.$t("getapi[8007]"), //及时完成率
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/purorderrate",
                        name: "4_purorderrate",
                        label: this.$t("getapi[965]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 532, 1),
                        url: "completionrate/purorderrate",
                    },
                    {
                        path: "/salorderratet",
                        name: "4_salorderratet",
                        label: this.$t("getapi[8010]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 533, 1),
                        url: "completionrate/salorderratet",
                    },
                    {
                        path: "/soorderrate",
                        name: "4_soorderrate",
                        label: this.$t("getapi[4039]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 534, 1),
                        url: "completionrate/soorderrate",
                    },
                    //WI工艺及时完成率
                    {
                        path: "/wicompleterate",
                        name: "4_wicompleterate",
                        label: this.$t("getapi[12021]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "completionrate/wicompleterate",
                    },
                ],
            },
            {
                label: this.$t("getapi[8030]"), //成本类
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/salratebycustom",
                        name: "4_salratebycustom",
                        label: this.$t("getapi[8031]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 541, 1),
                        url: "cost/salratebycustom",
                    },
                    {
                        path: "/monthmancharge",
                        name: "4_monthmancharge",
                        label: this.$t("getapi[8032]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 542, 1),
                        url: "cost/monthmancharge",
                    },
                    {
                        path: "/salsumstatics",
                        name: "4_salsumstatics",
                        label: this.$t("getapi[8036]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 543, 1),
                        url: "cost/salsumstatics",
                    },
                    {
                        path: "/ppvmonth",
                        name: "4_ppvmonth",
                        label: this.$t("getapi[969]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 544, 1),
                        url: "cost/ppvmonth",
                    },
                    {
                        path: "/bomrateex",
                        name: "4_bomrateex",
                        label: this.$t("getapi[12056]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "cost/bomrateex",
                    },
                ],
            },
            {
                label: this.$t("getapi[8015]"), //账龄类
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/invagingsum",
                        name: "4_invagingsum",
                        label: this.$t("getapi[8016]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 535, 1),
                        url: "aging/invagingsum",
                    },
                    {
                        path: "/invagingweeksum",
                        name: "4_invagingweeksum",
                        label: this.$t("getapi[12462]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 535, 1),
                        url: "aging/invagingweeksum",
                    },
                    {
                        path: "/invagingcategory",
                        name: "4_invagingcategory",
                        label: this.$t("getapi[8017]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 536, 1),
                        url: "aging/invagingcategory",
                    },
                    {
                        path: "/socompletedays",
                        name: "4_socompletedays",
                        label: this.$t("getapi[8018]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 537, 1),
                        url: "aging/socompletedays",
                    },
                    {
                        path: "/soinusecost",
                        name: "4_soinusecost",
                        label: this.$t("getapi[8021]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 538, 1),
                        url: "aging/soinusecost",
                    },
                ],
            },
            {
                label: this.$t("getapi[8037]"), //生产类
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/soforceclosemonthstatics",
                        name: "4_soforceclosemonthstatics",
                        label: this.$t("getapi[8038]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 545, 1),
                        url: "production/soforceclosemonthstatics",
                    },
                    {
                        path: "/costvariance",
                        name: "4_costvariance",
                        label: this.$t("getapi[8039]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 546, 1),
                        url: "production/costvariance",
                    },
                    {
                        path: "/partmaterialstatics",
                        name: "4_partmaterialstatics",
                        label: this.$t("getapi[8040]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 547, 1),
                        url: "production/partmaterialstatics",
                    },
                    {
                        path: "/oee",
                        name: "4_oee",
                        label: this.$t("getapi[12022]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "production/oee",
                    },
                    {
                        path: "/boardrate",
                        name: "4_boardrate",
                        label: this.$t("getapi[3460]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "production/boardrate",
                    },
                    {
                        path: "/dppm",
                        name: "4_dppm",
                        label: 'DPPM',
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "production/dppm",
                    },
                    {
                        path: "/weeklydppm",
                        name: "4_weeklydppm",
                        label: 'Weekly DPPM',
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "production/weeklydppm",
                    },
                    {
                        path: "/getmeterenergydatabyyear",
                        name: "4_getmeterenergydatabyyear",
                        label: this.$t("getapi[13542]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "production/getmeterenergydatabyyear",
                    },
                    {
                        path: "/getmeterenergydata",
                        name: "4_getmeterenergydata",
                        label: this.$t("getapi[13543]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: true,
                        url: "production/getmeterenergydata",
                    },
                ],
            },
            {
                label: this.$t("getapi[8012]"), //质量类
                icon: "caret-right",
                chb: true,
                visible: true,
                children: [
                    {
                        path: "/purreceivestatics",
                        name: "4_purreceivestatics",
                        label: this.$t("getapi[8013]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 539, 1),
                        url: "quality/purreceivestatics",
                    },
                    {
                        path: "/wxreceivestatics",
                        name: "4_wxreceivestatics",
                        label: this.$t("getapi[8014]"),
                        icon: "arrow-right",
                        chb: false,
                        visible: this.$limits.menuvisible("plv2", 540, 1),
                        url: "quality/wxreceivestatics",
                    },
                ],
            },

          ];
        this.menu5 = [
              {
                  label: this.$t('getapi[7975]'),
                  icon: "s-home",
                  chb: false,
                  visible: true,
              },
              {
                  label: this.$t('getapi[12213]'),
                  icon: "s-home",
                  chb: false,
                  visible: true,
              },
              {
                  label: this.$t("getapi[13646]"), //设备信息
                  icon: "caret-right",
                  chb: true,
                  visible: true,
                  children: [
                      /*{
                          path: "/devicecategorylist",
                          name: "5_devicecategorylist",
                          label: this.$t("getapi[13649]"),
                          icon: "arrow-right",
                          chb: false,
                          visible: this.$limits.menuvisible("plv2", 700, 1),
                          url: "device/devicecategorylist",
                      },*/
                  ],
              },
          ];
      },
      //跳转路由 根据名称跳转
      clickMenu(item) {
        //console.log('-------clickMenu------', item);
        let keep = [];
        if (
          sessionStorage.getItem("keepview") != null &&
          sessionStorage.getItem("keepview").length > 0
        ) {
          keep = JSON.parse(sessionStorage.getItem("keepview"));
        }
        console.log(keep.indexOf(item.name));
        if (keep.indexOf(item.name) < 0) {
          // console.log("插入缓存页面》》》》》",item.name,keep);
          keep.push(item.name);
          sessionStorage.setItem("keepview", JSON.stringify(keep));
          this.$forceUpdate();
        }

        this.$router.push(item).then((val) => {
          if (val.name == item.name) {
            this.$store.commit("selectMenu", item);

          }
        });
        //菜单栏搜索
          this.path = item.path
          if(item.label.indexOf(this.keyword) == -1){
              this.reSetKeyword()
          }
      },
      // 刷新登录信息
      refreshLoginInfo() {
        let that = this
        let LoginDB = JSON.parse(sessionStorage.getItem('userData')).Login_DB
        let LoginGroup = JSON.parse(sessionStorage.getItem('userData')).Login_Group
        let Login_Code = JSON.parse(sessionStorage.getItem('userData')).Login_Group
        let Login_Pwd = JSON.parse(sessionStorage.getItem('userData')).Login_Pwd
        that.$http.urlpost('/User/SYS_Users/GetUserInfoByToken', '', function (res) {
          if (res.Success == 1) {
            let reqdata = res;
            let userdata = {
              username: reqdata.Login_Name,
              plv1: reqdata.P_LV1,
              plv2: reqdata.P_LV2,
              plv3: reqdata.P_LV3,
              plv4: reqdata.P_LV4,
              token: reqdata.Token,
              Login_DB: LoginDB,
              Login_Group: LoginGroup,
              Login_Code: Login_Code,
              Login_Pwd: Login_Pwd,
              Company_Name: reqdata.Company_Name,
              inner_flag: reqdata.inner_flag
            };
            sessionStorage.setItem('userData', JSON.stringify(userdata));
          }
        })
      },
      /*changeTabs(tab, event) {
              let that = this
              setTimeout(function(){
                  if(tab.name == 1){
                      that.tab1 = true
                      that.tab2 = false
                      that.tab3 = false
                  } else if(tab.name == 2){
                      that.tab1 = false
                      that.tab2 = true
                      that.tab3 = false
                  } else if(tab.name == 3){
                      that.tab1 = false
                      that.tab2 = false
                      that.tab3 = true
                  }
              }, 500)
          },*/
      changeTabs(index) {
        let that = this;
          that.searchindex = -1
          that.selectitem = []
        console.log("index" + index);
        if (index == 1) {
          that.tab1 = true;
          that.tab2 = false;
          that.tab3 = false;
          that.tab4 = false;
          that.tab5 = false;
          that.activeTabName = "1";
            that.getSearchNode().filter(that.menu)
        } else if (index == 2) {
          that.tab1 = false;
          that.tab2 = true;
          that.tab3 = false;
          that.tab4 = false;
          that.tab5 = false;
          that.activeTabName = "2";
            that.getSearchNode().filter(that.menu2)
        } else if (index == 3) {
          that.tab1 = false;
          that.tab2 = false;
          that.tab3 = true;
          that.tab4 = false;
          that.tab5 = false;
          that.activeTabName = "3";
            that.getSearchNode().filter(that.menu3)
        } else if(index == 4){
            that.tab1 = false;
            that.tab2 = false;
            that.tab3 = false;
            that.tab4 = true;
            that.tab5 = false;
            that.activeTabName = "4";
            that.getSearchNode().filter(that.menu4)
        } else if(index == 5){
            that.tab1 = false;
            that.tab2 = false;
            that.tab3 = false;
            that.tab4 = false;
            that.tab5 = true;
            that.activeTabName = "5";
            that.getSearchNode().filter(that.menu5)
        }
      },
        reSetKeyword(){
            let that = this
            that.searchindex = -1
            that.selectitem = []
            if(that.activeTabName == 1){
                that.getSearchNode().filter(that.menu)
            } else if(that.activeTabName == 2){
                that.getSearchNode().filter(that.menu2)
            } else if(that.activeTabName == 3){
                that.getSearchNode().filter(that.menu3)
            } else if(that.activeTabName == 4){
                that.getSearchNode().filter(that.menu4)
            } else if(that.activeTabName == 5){
                that.getSearchNode().filter(that.menu5)
            }
        },
        previous(){
            let that = this
            if(that.keyword == ''){
                return
            }
            for(let i = (that.searchindex -1);i >= 0;i--){
                that.path = that.selectitem[i].path
                that.searchindex = i
                break
            }
        },
        next(){
          let that = this
          if(that.keyword == ''){
              return
          }
          console.log(that.selectitem)
            if(that.searchindex == -1){
                for(let i = 0;i<that.selectitem.length;i++){
                    that.path = that.selectitem[i].path
                    that.searchindex = i
                    break
                }
            } else {
                for(let i = (that.searchindex + 1);i<that.selectitem.length;i++){
                    that.path = that.selectitem[i].path
                    that.searchindex = i
                    break
                }
            }
      },
        getSearchNode:function(){
            let that = this
            let recursiveArray = function(arr){
                if(arr.label.indexOf(that.keyword) > -1 && arr.children == undefined){
                    that.selectitem.push(arr)
                }
                if(arr.children != undefined && arr.children.length != 0){
                    for (let array of arr.children){
                        recursiveArray(array)
                    }
                }
            }
            return{
                filter:function(data){
                    if(data.length == 0){
                        return
                    }
                    for (let rootMenu of data) {
                        recursiveArray(rootMenu)
                    }
                    return that.selectitem
                }
            }
        },
    },
  };
</script>

<style lang="less" scoped>
  /deep/ .el-tabs__item {
    color: white;
  }

  .el-menu {
    height: 100%;
    border: none;

    .logos {
      width: 65px;
    }

    .logo {
      width: 240px;
      font-size: medium;
    }

    h3 {
      display: flex;
      height: 60px;
      line-height: 40px;
      color: #fff;
      text-align: center;
      position: fixed;
      z-index: 1;
      cursor: pointer;

      .logimg {
        width: 40px;
        height: 40px;
        display: inline-block;
        margin: 8px 5px;
      }
    }
  }

  // .el-menu-item.is-active {
  //    background-color: rgb(231, 235, 240) !important;
  // }
  // li.el-menu-item {
  // 	background: #000000 !important;
  // }
  // .el-submenu__title {
  // 	background: #00ff7f !important;
  // }
  // .el-submenu>.el-submenu__title {
  //     background: #000000 !important;
  // }
/*  ul>li{
    max-width: 25%;
  }*/
  ul>li.el-submenu__title {
    background: #55ff00 !important;
  }

  ul>li>ul>li.el-submenu__title {
    background: #4a4747 !important;
  }

  .el-menu-demo:not(.el-menu--collapse) {
    width:100%;
    min-width: 240px;
    min-height: 400px;
  }
  .el-menu-item{
    padding: 0px 12px 0px 12px
  }
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }
  /deep/.icon_black{
    .el-submenu__title i{
      color:#000
    }
    .el-menu-item i{
      color:#000
    }
  }
  /deep/.icon_green{
    .el-submenu__title i{
      color:#dadce0
    }
    /*.el-menu-item:hover {
      background: #1c88cf !important;
      color: #fff !important;
    }
    .el-submenu__title:hover {
      background: #1c88cf !important;
      color: #fff !important;
    }*/
    .el-menu-item i{
      color:#dadce0
    }
  }
</style>